function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "ebf7d176-5ffd-4420-bcca-304f4f77ac7a",
  x1: 466.94,
  y1: 739.84,
  x2: 466.94,
  y2: 527.44,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "gray",
  stopOpacity: 0.25
}), React.createElement("stop", {
  offset: 0.54,
  stopColor: "gray",
  stopOpacity: 0.12
}), React.createElement("stop", {
  offset: 1,
  stopColor: "gray",
  stopOpacity: 0.1
})), React.createElement("linearGradient", {
  id: "ffba99e4-d350-4cb7-a6ec-0715674198cb",
  x1: -222.1,
  y1: 711.31,
  x2: -222.1,
  y2: 269.19,
  gradientTransform: "translate(1052.52 21.29) rotate(-2.2)",
  xlinkHref: "#ebf7d176-5ffd-4420-bcca-304f4f77ac7a"
}), React.createElement("linearGradient", {
  id: "f94edff0-5540-4209-9ffe-d34bff61dab8",
  x1: 197.37,
  y1: 744.56,
  x2: 197.37,
  y2: 339.73,
  xlinkHref: "#ebf7d176-5ffd-4420-bcca-304f4f77ac7a"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("title", null, "status update");

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M687,263.23c-70.76.54-138.73-15.45-203.73-33.27s-129.47-37.83-198.84-46c-44.62-5.28-95.4-4.45-130.48,16-33.75,19.66-43.73,51.88-48.66,81.62-3.71,22.38-5.52,45.86,7.54,66.23,9.07,14.13,24.69,25.73,35.68,39.19,38.26,46.84,14.54,107.11-23.4,155.51C107.34,565.18,86.54,587,73,611s-19.18,51.11-5.79,74.6c13.28,23.29,43.54,40.06,76.08,51.45,66.1,23.14,143.17,27.7,218.23,29.17,166.14,3.24,332.71-6.64,498.82-16.51,61.48-3.65,123.23-7.33,183.48-17.15,33.46-5.45,67.93-13.43,91.75-30.6,30.24-21.8,36.68-57.12,15-82.34-36.37-42.29-133-49.68-159-95.53-14.31-25.24-1.57-54.37,17-78.91,39.94-52.65,108.34-100,109.95-158.63,1.11-40.25-34-79.28-86.68-96.43-55.24-18-130.78-12.79-169.84,21.62C821.84,247.11,749.5,262.76,687,263.23Z",
  transform: "translate(-36.6 -133.2)",
  fill: "#fd8d68",
  opacity: 0.1
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M965.57,684.13s-12.29-8.11-24.47-2.35c0,0,3.75,7.23,19.17,6.54Z",
  transform: "translate(-36.6 -133.2)",
  fill: "#fd8d68"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M967.08,684.56s3.74,14.24-5.63,23.93c0,0-5.64-5.87-.05-20.25Z",
  transform: "translate(-36.6 -133.2)",
  fill: "#fd8d68"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M982.41,670.89s-.91-12.11-28.26-8.1c0,0-.12,7.82,9.48,11.52S977.62,674.89,982.41,670.89Z",
  transform: "translate(-36.6 -133.2)",
  fill: "#fd8d68"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M984.09,670.81s11.56,3.71,1.25,29.36c0,0-7.62-1.7-9-11.91S979.08,674.52,984.09,670.81Z",
  transform: "translate(-36.6 -133.2)",
  fill: "#fd8d68"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M999.57,653.62s1.57-19.93-26.38-17.88c0,0-2,18,21.45,22.68Z",
  transform: "translate(-36.6 -133.2)",
  fill: "#fd8d68"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1018,631.13s-3.83-22.59-31.76-15.86c0,0-.11,19.53,27.2,21.24Z",
  transform: "translate(-36.6 -133.2)",
  fill: "#fd8d68"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1031.54,607.87s-6.42-22-34.1-15.42c0,0,6.59,19.79,32.26,19.48Z",
  transform: "translate(-36.6 -133.2)",
  fill: "#fd8d68"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1044.36,585.15s-6.27-22.83-33-16c0,0,8.92,21.69,31.23,19.87Z",
  transform: "translate(-36.6 -133.2)",
  fill: "#fd8d68"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1052.63,563.57s-4.82-27.92-29.74-21.74c0,0,7.23,25.4,27.9,25.8Z",
  transform: "translate(-36.6 -133.2)",
  fill: "#fd8d68"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1060.37,537.5s-5.78-28.15-31-20c0,0,9.89,26.6,29.22,23.85Z",
  transform: "translate(-36.6 -133.2)",
  fill: "#fd8d68"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1065.17,513.23s-9.19-28.14-28.68-27.38c0,0,9.4,29.73,27,33Z",
  transform: "translate(-36.6 -133.2)",
  fill: "#fd8d68"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1068.22,489.56s-10-33.88-25.87-31.27c0,0,6.93,25.9,25.3,36.55Z",
  transform: "translate(-36.6 -133.2)",
  fill: "#fd8d68"
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1070,461.28s-9.37-28.23-25-29.36c0,0,6.37,27.78,24.68,36.69Z",
  transform: "translate(-36.6 -133.2)",
  fill: "#fd8d68"
});

var _ref18 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1071.84,435s-11.69-28.26-22-28.9c0,0,5.08,27.83,21,33.54Z",
  transform: "translate(-36.6 -133.2)",
  fill: "#fd8d68"
});

var _ref19 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1073.14,410.43s-7.18-30.7-17.52-33.24c0,0,1.41,25.11,16.48,35.54Z",
  transform: "translate(-36.6 -133.2)",
  fill: "#fd8d68"
});

var _ref20 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1077,378.34s-7.56-24.46-15.93-28.19c0,0,1.66,28.84,14,34.18Z",
  transform: "translate(-36.6 -133.2)",
  fill: "#fd8d68"
});

var _ref21 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1080.26,357.27l1.53-43.14s-15.62,32.56-2.68,50.75Z",
  transform: "translate(-36.6 -133.2)",
  fill: "#fd8d68"
});

var _ref22 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1092.35,314.4s11.26-31.5,14-33.26c0,0-22.1,20.44-19.94,46.73Z",
  transform: "translate(-36.6 -133.2)",
  fill: "#fd8d68"
});

var _ref23 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1000.34,653.48s19.82-2.6,19.22,25.42c0,0-17.91,2.91-23.75-20.25Z",
  transform: "translate(-36.6 -133.2)",
  fill: "#fd8d68"
});

var _ref24 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1019,630.37s22.91-.07,21,28.6c0,0-19.22,3.43-25.57-23.18Z",
  transform: "translate(-36.6 -133.2)",
  fill: "#fd8d68"
});

var _ref25 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1031.76,609.72s20.79-9.75,34.1,15.42c0,0-19.21,8.12-35.93-11.35Z",
  transform: "translate(-36.6 -133.2)",
  fill: "#fd8d68"
});

var _ref26 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1044.82,585.36s21.29-10.37,33.79,14.21c0,0-22.17,7.64-35.54-10.32Z",
  transform: "translate(-36.6 -133.2)",
  fill: "#fd8d68"
});

var _ref27 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1052.35,564.18s20.49-19.58,36.85.22c0,0-20.94,16.1-37.79,4.14Z",
  transform: "translate(-36.6 -133.2)",
  fill: "#fd8d68"
});

var _ref28 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1059.21,536.83s20.62-20,36.84.92c0,0-23.14,16.43-37.57,3.28Z",
  transform: "translate(-36.6 -133.2)",
  fill: "#fd8d68"
});

var _ref29 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1063.07,512.43s15.88-25,34.57-19.41c0,0-16.47,26.47-34.4,25.29Z",
  transform: "translate(-36.6 -133.2)",
  fill: "#fd8d68"
});

var _ref30 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1067.75,489.4s16-31.49,31.13-26c0,0-11.53,24.2-31.54,31.31Z",
  transform: "translate(-36.6 -133.2)",
  fill: "#fd8d68"
});

var _ref31 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1068.85,459.67s16.45-24.78,31.86-21.76c0,0-13.45,25.13-33.45,28.93Z",
  transform: "translate(-36.6 -133.2)",
  fill: "#fd8d68"
});

var _ref32 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1070.1,434.39s12.75-27.8,23.12-28c0,0-6.13,27.61-22.26,32.72Z",
  transform: "translate(-36.6 -133.2)",
  fill: "#fd8d68"
});

var _ref33 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1072.63,409.83s14.17-28.17,24.82-28.22c0,0-7.25,24.08-24.35,30.69Z",
  transform: "translate(-36.6 -133.2)",
  fill: "#fd8d68"
});

var _ref34 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1074.76,380.07s10.6-23.3,19.38-25.94c0,0-5.3,28.4-18.21,32.12Z",
  transform: "translate(-36.6 -133.2)",
  fill: "#fd8d68"
});

var _ref35 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1081.52,356.45l23.69-36.08s-6.07,35.6-27.14,43Z",
  transform: "translate(-36.6 -133.2)",
  fill: "#fd8d68"
});

var _ref36 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1097.78,317.3s27.54-19,28.53-22.08c0,0-14,26.62-40,31.32Z",
  transform: "translate(-36.6 -133.2)",
  fill: "#fd8d68"
});

var _ref37 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1099.43,308.75s31.61-30.38,39.68-30.35c0,0-26.07,1.19-40.44,28.74Z",
  transform: "translate(-36.6 -133.2)",
  fill: "#fd8d68"
});

var _ref38 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1075.07,384.58l1.15.15c5.94-46.5,14.6-74,24.39-77.37l-.38-1.1C1089.85,309.86,1081.15,336.94,1075.07,384.58Z",
  transform: "translate(-36.6 -133.2)",
  fill: "#444053"
});

var _ref39 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1066.34,495.75l1.74.15c.36-4.34.64-8.79.83-13.21,1.66-38.48,4.23-73.82,7.62-100.31l-1-1.25c-3.39,26.54-6.69,62.95-8.35,101.49C1067,487,1066.7,491.44,1066.34,495.75Z",
  transform: "translate(-36.6 -133.2)",
  fill: "#444053"
});

var _ref40 =
/*#__PURE__*/
React.createElement("path", {
  d: "M933.11,706.26c.31-.13,30.94-13.81,62.73-46.44a252.42,252.42,0,0,0,45.85-65c14.69-29.93,23.65-66.71,26.66-102.44l-1.82.85c-6.74,80.2-43.26,135-72.29,164.85-31.48,32.33-61.76,45.87-62.06,46Z",
  transform: "translate(-36.6 -133.2)",
  fill: "#444053"
});

var _ref41 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1006.45,164.39V682.81c0,15.41-14.87,28-33.23,28H269.85c-18.36,0-33.23-12.54-33.23-28V164.39c0-15.44,14.87-31.19,33.23-31.19l703.33,1.71C991.54,134.91,1006.45,149,1006.45,164.39Z",
  transform: "translate(-36.6 -133.2)",
  fill: "#fff"
});

var _ref42 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1006.45,164.55v24H236.62v-24A31.35,31.35,0,0,1,268,133.2H975.11A31.35,31.35,0,0,1,1006.45,164.55Z",
  transform: "translate(-36.6 -133.2)",
  fill: "#3f3d56"
});

var _ref43 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 237.32,
  cy: 27.67,
  r: 11.08,
  fill: "#fa5959",
  opacity: 0.8
});

var _ref44 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 269.55,
  cy: 27.67,
  r: 11.08,
  fill: "#fed253",
  opacity: 0.8
});

var _ref45 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 301.78,
  cy: 27.67,
  r: 11.08,
  fill: "#8ccf4d",
  opacity: 0.8
});

var _ref46 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.2
}, React.createElement("path", {
  d: "M690,323v56c0,1.67-3.13,3-7,3H535.28c-3.86,0-7-1.35-7-3V323c0-1.67,3.12-3.37,7-3.37H683C686.88,319.62,690,321.32,690,323Z",
  transform: "translate(-36.6 -133.2)",
  fill: "#fd8d68"
}));

var _ref47 =
/*#__PURE__*/
React.createElement("rect", {
  x: 562.67,
  y: 206.42,
  width: 76.96,
  height: 2.72,
  fill: "#fd8d68"
});

var _ref48 =
/*#__PURE__*/
React.createElement("path", {
  d: "M560.33,333.66a18.25,18.25,0,0,0-10.06,33.47v-1.21a4.15,4.15,0,0,1,3.65-4.11,7.24,7.24,0,0,0,12.7,0,4.15,4.15,0,0,1,3.65,4.11v1.29a18.25,18.25,0,0,0-9.94-33.55Zm7.16,23.14a7.23,7.23,0,0,1-14.43,0,7.92,7.92,0,0,1,4.15-10.61,2.46,2.46,0,0,1-.39-1.31,2.41,2.41,0,0,1,2.42-2.41h.17a2.41,2.41,0,0,0-2.24,2.4,2.44,2.44,0,0,0,.32,1.2l.07,0a2.61,2.61,0,0,1,0-.48,2.35,2.35,0,0,1,.46-1.4,2.4,2.4,0,0,1,2.3-1.7h.17a2.39,2.39,0,0,0-1.84,1.08,2.34,2.34,0,0,1,1.33-.4,2.41,2.41,0,0,1,2.41,2.41,2.45,2.45,0,0,1,0,.27,7.93,7.93,0,0,1,5.88,7.66A8.07,8.07,0,0,1,567.49,356.8Z",
  transform: "translate(-36.6 -133.2)",
  fill: "#fd8d68",
  opacity: 0.2
});

var _ref49 =
/*#__PURE__*/
React.createElement("rect", {
  x: 562.67,
  y: 213.04,
  width: 76.96,
  height: 2.72,
  fill: "#fd8d68",
  opacity: 0.2
});

var _ref50 =
/*#__PURE__*/
React.createElement("rect", {
  x: 562.67,
  y: 219.66,
  width: 76.96,
  height: 2.72,
  fill: "#fd8d68",
  opacity: 0.2
});

var _ref51 =
/*#__PURE__*/
React.createElement("rect", {
  x: 562.67,
  y: 226.29,
  width: 76.96,
  height: 2.72,
  fill: "#fd8d68",
  opacity: 0.2
});

var _ref52 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.2
}, React.createElement("path", {
  d: "M516.59,432.67v56c0,1.66-3.12,3-7,3H361.87c-3.86,0-7-1.36-7-3v-56c0-1.67,3.12-3.37,7-3.37H509.61C513.47,429.3,516.59,431,516.59,432.67Z",
  transform: "translate(-36.6 -133.2)",
  fill: "#fd8d68"
}));

var _ref53 =
/*#__PURE__*/
React.createElement("rect", {
  x: 389.25,
  y: 316.1,
  width: 76.96,
  height: 2.72,
  fill: "#fd8d68"
});

var _ref54 =
/*#__PURE__*/
React.createElement("path", {
  d: "M386.92,443.33a18.25,18.25,0,0,0-10.06,33.48v-1.22a4.14,4.14,0,0,1,3.65-4.1,7.24,7.24,0,0,0,12.7,0,4.14,4.14,0,0,1,3.65,4.1v1.3a18.25,18.25,0,0,0-9.94-33.56Zm7.15,23.14a7.23,7.23,0,0,1-14.43,0,8,8,0,0,1-.71-3.29,7.94,7.94,0,0,1,4.86-7.32,2.39,2.39,0,0,1-.38-1.3,2.42,2.42,0,0,1,2.41-2.42H386a2.41,2.41,0,0,0-1.93,3.6l.08,0a2.42,2.42,0,0,1,0-.47,3.54,3.54,0,0,1,2.76-3.11H387a2.42,2.42,0,0,0-1.84,1.08,2.39,2.39,0,0,1,1.32-.4,2.42,2.42,0,0,1,2.42,2.42,2.45,2.45,0,0,1,0,.27,7.92,7.92,0,0,1,5.16,11Z",
  transform: "translate(-36.6 -133.2)",
  fill: "#fd8d68",
  opacity: 0.2
});

var _ref55 =
/*#__PURE__*/
React.createElement("rect", {
  x: 389.25,
  y: 322.72,
  width: 76.96,
  height: 2.72,
  fill: "#fd8d68",
  opacity: 0.2
});

var _ref56 =
/*#__PURE__*/
React.createElement("rect", {
  x: 389.25,
  y: 329.34,
  width: 76.96,
  height: 2.72,
  fill: "#fd8d68",
  opacity: 0.2
});

var _ref57 =
/*#__PURE__*/
React.createElement("rect", {
  x: 389.25,
  y: 335.96,
  width: 76.96,
  height: 2.72,
  fill: "#fd8d68",
  opacity: 0.2
});

var _ref58 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.2
}, React.createElement("path", {
  d: "M476.7,255.08v56c0,1.66-3.12,3-7,3H322c-3.85,0-7-1.36-7-3v-56c0-1.67,3.13-3.37,7-3.37H469.72C473.58,251.71,476.7,253.41,476.7,255.08Z",
  transform: "translate(-36.6 -133.2)",
  fill: "#fd8d68"
}));

var _ref59 =
/*#__PURE__*/
React.createElement("rect", {
  x: 349.36,
  y: 138.51,
  width: 76.96,
  height: 2.72,
  fill: "#fd8d68"
});

var _ref60 =
/*#__PURE__*/
React.createElement("rect", {
  x: 349.36,
  y: 145.13,
  width: 76.96,
  height: 2.72,
  fill: "#fd8d68",
  opacity: 0.2
});

var _ref61 =
/*#__PURE__*/
React.createElement("rect", {
  x: 349.36,
  y: 151.75,
  width: 76.96,
  height: 2.72,
  fill: "#fd8d68",
  opacity: 0.2
});

var _ref62 =
/*#__PURE__*/
React.createElement("rect", {
  x: 349.36,
  y: 158.37,
  width: 76.96,
  height: 2.72,
  fill: "#fd8d68",
  opacity: 0.2
});

var _ref63 =
/*#__PURE__*/
React.createElement("path", {
  d: "M347,265.74A18.26,18.26,0,0,0,337,299.22v-3.09a4.15,4.15,0,0,1,3.65-4.11,7.24,7.24,0,0,0,12.7,0,4.14,4.14,0,0,1,3.65,4.11v3.16A18.25,18.25,0,0,0,347,265.74Zm8,22.28a1.23,1.23,0,0,1-.24.31,1,1,0,0,1-.53.18l-.37,0a7.25,7.25,0,0,1-14.19-2.06,7.14,7.14,0,0,1,.95-3.56l-.08-.05a2.41,2.41,0,0,1,.24-3.35,4.82,4.82,0,0,1,1.5-.55,6.7,6.7,0,0,0,3.8-2.91,8,8,0,0,1,0,1.1,1.61,1.61,0,0,1,2.29-.08,4.6,4.6,0,0,0,.65.74,2,2,0,0,0,.81.23l1.82.23a3.48,3.48,0,0,1,2.07.75,3.28,3.28,0,0,1,.69,1.22,18.24,18.24,0,0,1,1.19,3.85A6.17,6.17,0,0,1,355.05,288Z",
  transform: "translate(-36.6 -133.2)",
  fill: "#fd8d68",
  opacity: 0.2
});

var _ref64 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.2
}, React.createElement("path", {
  d: "M730.37,520v56c0,1.67-3.12,3-7,3H575.64c-3.86,0-7-1.35-7-3V520c0-1.67,3.12-3.36,7-3.36H723.39C727.25,516.59,730.37,518.28,730.37,520Z",
  transform: "translate(-36.6 -133.2)",
  fill: "#fd8d68"
}));

var _ref65 =
/*#__PURE__*/
React.createElement("rect", {
  x: 603.03,
  y: 403.38,
  width: 76.96,
  height: 2.72,
  fill: "#fd8d68"
});

var _ref66 =
/*#__PURE__*/
React.createElement("rect", {
  x: 603.03,
  y: 410,
  width: 76.96,
  height: 2.72,
  fill: "#fd8d68",
  opacity: 0.2
});

var _ref67 =
/*#__PURE__*/
React.createElement("rect", {
  x: 603.03,
  y: 416.63,
  width: 76.96,
  height: 2.72,
  fill: "#fd8d68",
  opacity: 0.2
});

var _ref68 =
/*#__PURE__*/
React.createElement("rect", {
  x: 603.03,
  y: 423.25,
  width: 76.96,
  height: 2.72,
  fill: "#fd8d68",
  opacity: 0.2
});

var _ref69 =
/*#__PURE__*/
React.createElement("path", {
  d: "M600.69,530.62a18.25,18.25,0,0,0-10.06,33.47V561a4.15,4.15,0,0,1,3.65-4.1,7.24,7.24,0,0,0,12.7,0,4.14,4.14,0,0,1,3.65,4.1v3.17a18.25,18.25,0,0,0-9.94-33.55Zm8,22.27a1.12,1.12,0,0,1-.24.32,1,1,0,0,1-.53.18h-.38a7.24,7.24,0,1,1-13.23-5.62l-.08,0a2.41,2.41,0,0,1,.24-3.35,4.82,4.82,0,0,1,1.5-.55,6.69,6.69,0,0,0,3.8-2.9,8,8,0,0,1,0,1.1,1.61,1.61,0,0,1,2.29-.08,4.14,4.14,0,0,0,.65.73,1.91,1.91,0,0,0,.81.24l1.82.23a3.42,3.42,0,0,1,2.07.75,3.28,3.28,0,0,1,.69,1.22,18.06,18.06,0,0,1,1.19,3.85A6.14,6.14,0,0,1,608.72,552.89Z",
  transform: "translate(-36.6 -133.2)",
  fill: "#fd8d68",
  opacity: 0.2
});

var _ref70 =
/*#__PURE__*/
React.createElement("path", {
  d: "M556.16,703.48l-21.94-31.81s-.41-7.88-1.85-9.72-.31-5.93-.31-5.93,1.54-2.25.21-2.46-.21-5.22-.21-5.22l-.1-8s1.23-7.68.21-9.52a3,3,0,0,1,.1-3.27s1.23-4.4,0-5.53-.93-8-.62-13.4-2.15-8.49-2.15-9.31-8.1-8.79-8.1-9.51-5.13-3.68-8.21-4.5-4.61-1.43-4.51-1.84-4.82-2-4.82-2-4.3-.31-5.95-2.45-6.65-2.78-6.8-2.79l-.09-.43-.09-.46c.38-.65.74-1.32,1.07-2,.1-.21.19-.41.28-.62a8.78,8.78,0,0,0,5.05-1.57,6.85,6.85,0,0,0,2.45-4.91,10.83,10.83,0,0,0-1.19-5.45c-.9-1.84-2.22-3.75-1.77-5.75.2-.86.72-1.62,1-2.46a6.5,6.5,0,0,0-.74-4.85c-.77-1.48-1.85-2.79-2.72-4.23a16.42,16.42,0,0,1-2.16-6,9.24,9.24,0,0,0-.8-3.26,6.24,6.24,0,0,0-1.8-1.82,18,18,0,0,0-11-3.34c-2.79.1-5.58.85-8.35.51a30.6,30.6,0,0,1-4.87-1.27c-3.44-1-7.41-1.44-10.4.53s-4.19,5.84-6.22,8.87c-1.8,2.67-4.42,4.92-5.79,7.76,0-.06,0-.11,0-.17a9.86,9.86,0,0,0-.76,2.07,14.74,14.74,0,0,0,.45,6.78,4.72,4.72,0,0,0,1.66,3c1,.65,2.4.5,3.59.71-.05.19-.1.39-.14.58a23,23,0,0,0-.51,4.87A23.44,23.44,0,0,0,464,585.78c0,.21,0,.42,0,.62a16.37,16.37,0,0,1-.1,1.76h0s-10.31-2.12-13.07-.68-8.21,2.55-9,3.37-2.87.21-4.72,5-2.05,9.72-4.4,12-3.59,3.79-3.7,5.43.31,2-.61,2.55-2.26,2.66-1.85,3.48a2.9,2.9,0,0,1-1.13,3.07,3.41,3.41,0,0,0-1.43,3.07s-.62,2.25-2.05,2.76-2.36,3.89-2.36,3.89l-4.65,5.35-9.22-10.2a3.89,3.89,0,0,0-5.48-.28L395.69,631a8.94,8.94,0,0,0-4.53,2.7,11.75,11.75,0,0,0-2.34,3.49l-2.48,2.23a6.28,6.28,0,0,0-.64,6.95l5.91,6.53,0,.06a10.33,10.33,0,0,0-5.71,2.32c-8.81,7.78-8.92,14.94-7.58,18.21s12.51,15.86,12.51,15.86,6.49,8.44,15.86,12.93h0l-.07.07c-.19.2-.37.41-.55.64l-.15.2a1.43,1.43,0,0,0-.14.2l-.17.24-.13.2-.18.3-.11.19-.21.4s-.05.09-.07.13-.17.37-.25.56l-.09.21c0,.13-.1.27-.16.4l-.09.27c0,.13-.09.26-.13.4l-.09.29q-.06.21-.12.45c0,.09-.05.18-.07.27s-.11.49-.16.74a2.5,2.5,0,0,0,0,.29,4.51,4.51,0,0,0-.09.53c0,.12,0,.24-.05.37s-.05.33-.07.51,0,.25,0,.39,0,.38,0,.58l0,.36c0,.32,0,.65,0,1-.21,12,.49,13.71.49,13.71a6.64,6.64,0,0,0,5.44,4.08,7.17,7.17,0,0,0,1.76-.09c5.33-.93,17.84-3.07,22.25-2.25,2.65.49,7.56-.24,11.05-.9l.92-.18.64,2,2-.56,1.72,1,1.09.62c2,6.86,10.24,4.52,10.24,4.52l1.95,1.13,19.79.51a39.78,39.78,0,0,0,7,3.36,6.29,6.29,0,0,0,1,.22,44.38,44.38,0,0,0,5.51.1c1.52,0,2.69-.1,2.69-.1s-.2-5.37-.49-11.39a161.45,161.45,0,0,0,18.33-1.5c10.57-1.86,15-11.47,16.6-16.6a46.9,46.9,0,0,1,1,6.37,46.46,46.46,0,0,0,1.64,5.52,18.45,18.45,0,0,0,2.26,4.1c7.79-2.66,3.07-6.65,1.43-8.39s1.13-3.17,1.13-3.17,2.16-1.44,2-2.77-.31-2.76,6.67-2.66S556.16,703.48,556.16,703.48ZM447.88,638.16c.09.59,1.06,6.89,1.94,8.55a10.9,10.9,0,0,1,.23,3.37c-4.13-.33-8.43-.51-8.43-.51a1,1,0,0,1,.22.53l-.65-.15-.95-.23,7.62-11.57Zm-15.08,24,7.15,1.14.6.09a25.52,25.52,0,0,0-.37,3.38c0,.1.16.23.39.38a10.74,10.74,0,0,0-.14,1.69c.12.57,3.46,1.79,7.3,2.81-.06.2-.11.4-.16.58h0c-3.39-1.78-8.72-2.61-9.34-3.93s-18.76-7.67-18.76-7.67-.67-.35-1.81-.9l4.78.9,1.31-.13A71.46,71.46,0,0,0,432.8,662.15Z",
  transform: "translate(-36.6 -133.2)",
  fill: "url(#ebf7d176-5ffd-4420-bcca-304f4f77ac7a)"
});

var _ref71 =
/*#__PURE__*/
React.createElement("path", {
  d: "M532.82,707.93s-2.85,17.18-17.28,19.72-62.6,2-62.6,2-27.54-4-37.5-27.23-16.37-32.53-7.83-32.93,54.58,15.55,57.22,15.75S535.36,649.9,532.82,707.93Z",
  transform: "translate(-36.6 -133.2)",
  fill: "#65617d"
});

var _ref72 =
/*#__PURE__*/
React.createElement("path", {
  d: "M532.82,707.93s-2.85,17.18-17.28,19.72-62.6,2-62.6,2-27.54-4-37.5-27.23-16.37-32.53-7.83-32.93,54.58,15.55,57.22,15.75S535.36,649.9,532.82,707.93Z",
  transform: "translate(-36.6 -133.2)",
  opacity: 0.05
});

var _ref73 =
/*#__PURE__*/
React.createElement("path", {
  d: "M403.63,727A6.59,6.59,0,0,0,409,731.1a7,7,0,0,0,1.74-.1c5.28-.91,17.68-3,22.05-2.23,2.63.49,7.5-.24,11-.89,2.3-.43,4-.84,4-.84s-4.06-13.52-4.57-13.92S424.89,702,424.89,702l-14.09-1h0a7.41,7.41,0,0,0-4.77,2.81c-1.49,1.8-2.77,4.75-2.85,9.59C402.93,725.31,403.63,727,403.63,727Z",
  transform: "translate(-36.6 -133.2)",
  fill: "#3f3d56"
});

var _ref74 =
/*#__PURE__*/
React.createElement("path", {
  d: "M403.63,727A6.59,6.59,0,0,0,409,731.1a57.66,57.66,0,0,1-3.82-5.58l.07-9.86A17.38,17.38,0,0,1,410.8,701h0s-7.42.51-7.62,12.4S403.63,727,403.63,727Z",
  transform: "translate(-36.6 -133.2)",
  opacity: 0.05
});

var _ref75 =
/*#__PURE__*/
React.createElement("path", {
  d: "M464.73,705.49l13.11-10.26,20.63-20.33-5.59-.25c-.84.53-3.18,2.21-3.27,4.25-.1,2.48-5.57.17-8.42,1.59S464.42,699.73,462,699.62s-4.37-1.24-5.38.49a1,1,0,0,1-.08.11Z",
  transform: "translate(-36.6 -133.2)",
  opacity: 0.1
});

var _ref76 =
/*#__PURE__*/
React.createElement("path", {
  d: "M406,703.83l1.42.65c10,4.27,22.25,13.21,23.17,14.84.56,1,7.69,5.32,13.19,8.56,2.3-.43,4-.84,4-.84s-4.06-13.52-4.57-13.92S424.89,702,424.89,702l-14.09-1h0A7.41,7.41,0,0,0,406,703.83Z",
  transform: "translate(-36.6 -133.2)",
  opacity: 0.1
});

var _ref77 =
/*#__PURE__*/
React.createElement("path", {
  d: "M378.34,674.7c1.32,3.25,12.4,15.75,12.4,15.75s7,9.15,17,13.42,22.26,13.21,23.17,14.84c.59,1,8.53,5.82,14.12,9.11l1.26.73,2.77,1.61,1.47.84s3.4-2.73,6.79-5.48,6.68-5.44,6.73-5.59c.1-.31,1.42-3.76,1.11-4-.16-.1-.85-1.51-2.14-3.14a14.41,14.41,0,0,0-5.17-4.28,14.68,14.68,0,0,1-6.71-7s-.45-.32-1.12-.75a13.6,13.6,0,0,0-4.57-2c-2.24-.28-6.4-4.85-6.4-4.85a12.53,12.53,0,0,1-4-4.17c-1.07-2.23-16.83-13-18.29-14L455,700.23l9.15,5.87,13.11-10.26,20.63-20.33-6.81-.3c-10-.44-27.83-1.12-30.08-.61a17,17,0,0,1-5.59.36s-5.08.23-8.43-1.54-8.65-2.6-9.26-3.91-18.6-7.62-18.6-7.62-24.49-13-33.23-5.28S377,671.45,378.34,674.7Z",
  transform: "translate(-36.6 -133.2)",
  fill: "#65617d"
});

var _ref78 =
/*#__PURE__*/
React.createElement("path", {
  d: "M457.31,600.1l3.15,10.47,4.06,23.58,14.94,1,4.33-7.18,4.31-7.15s2.69-9.53,4.63-18.75c1.71-8.15,2.82-16.07,1-16.93-1.65-.76-2.73-3.51-3.44-6.46-.09-.36-.17-.73-.24-1.1a57.52,57.52,0,0,1-1-7.58s-31.31-1.63-26.94,11.28a20.38,20.38,0,0,1,1.18,6.86,16.33,16.33,0,0,1-.1,1.75A14.63,14.63,0,0,1,457.31,600.1Z",
  transform: "translate(-36.6 -133.2)",
  fill: "#ee8e9e"
});

var _ref79 =
/*#__PURE__*/
React.createElement("path", {
  d: "M450.8,598.37l1.12,17.79,2.54,15.14,2.85,7,2.54,38.36s24.5,2.84,30.46,0a2.61,2.61,0,0,0,1.08-.84c7.2-10.87,4.84-42.35,4.84-42.35L499,613.11l-1.83-10.55-4.42-.47-3.41-.36s-.77.94-1.87,2.41c-3,4-8.56,11.8-8.19,15.07.51,4.47-.61,9-2.34,9.75s-3.15,1.94-3.45.72a5.5,5.5,0,0,1-.31-3.25c.31-1.73-1.32-7-1.32-7s-2.74-6.2-2.54-8.84-.3-5.69-1.12-6.4-1.93-1.43-1-4.68-4-9.58-4-9.58Z",
  transform: "translate(-36.6 -133.2)",
  fill: "#e3e8f4"
});

var _ref80 =
/*#__PURE__*/
React.createElement("path", {
  d: "M483.17,642.79l1,30.39,5.87,3.26a2.54,2.54,0,0,0,1.08-.85c7.2-10.87,4.84-42.35,4.84-42.35l2.74-20.33-1.83-10.55-4.42-.47c1.71-8.15,2.83-16.06,1-16.92-1.65-.77-2.74-3.51-3.44-6.46h0L486.83,600s.27,1.93.36,3.93a11.13,11.13,0,0,1-.26,3.79c-.71,1.83-.2,5.08-.2,5.08-1.83,3.23-2.75,9.21-3.19,15C482.94,635.48,483.17,642.79,483.17,642.79Z",
  transform: "translate(-36.6 -133.2)",
  opacity: 0.1
});

var _ref81 =
/*#__PURE__*/
React.createElement("path", {
  d: "M490.1,578s5.12.64,6.74,2.77,5.9,2.44,5.9,2.44,4.88,1.63,4.77,2,1.43,1,4.48,1.83,8.13,3.76,8.13,4.48,8,8.63,8,9.45,2.43,3.86,2.13,9.25-.61,12.19.61,13.31,0,5.49,0,5.49a3,3,0,0,0-.1,3.25c1,1.83-.21,9.45-.21,9.45l.11,7.93s-1.12,5,.2,5.18-.2,2.44-.2,2.44-1.12,4.07.3,5.9,1.83,9.65,1.83,9.65l21.75,31.61s.3,5.79-6.61,5.69-6.81,1.32-6.6,2.64-1.93,2.75-1.93,2.75-2.75,1.42-1.12,3.15,6.3,5.69-1.42,8.33a18.38,18.38,0,0,1-2.24-4.06,47.34,47.34,0,0,1-1.63-5.49s-.71-7.73-2.13-8.74-1.22-5.9-1.22-5.9,2-4-.81-5.59-44.11-24.49-44.11-24.49l-1-30.39s-.71-22.46,3.56-30c0,0-.51-3.25.2-5.08s-.1-7.73-.1-7.73Z",
  transform: "translate(-36.6 -133.2)",
  fill: "#3f3d56"
});

var _ref82 =
/*#__PURE__*/
React.createElement("path", {
  d: "M463.46,590.22s-10.22-2.11-13-.69-8.13,2.54-8.94,3.36-2.85.2-4.68,5-2,9.65-4.37,11.89-3.56,3.76-3.66,5.38.31,2-.61,2.54-2.23,2.65-1.83,3.46,21.14,18.7,21.14,18.7,1,6.81,1.93,8.54-1,25.51-3.05,27.13S460.15,677,460.15,677s.72-15.6,1.33-16.42-.41-17.48-.41-17.48-.1-14.23,1.22-18,1.17-16.26,1.17-16.26,1.17-7.5,2.59-9.25S463.46,590.22,463.46,590.22Z",
  transform: "translate(-36.6 -133.2)",
  opacity: 0.1
});

var _ref83 =
/*#__PURE__*/
React.createElement("path", {
  d: "M463.16,589.91s-10.22-2.1-13-.68-8.13,2.54-8.94,3.35-2.85.21-4.67,5-2,9.66-4.37,11.89-3.56,3.76-3.66,5.39.3,2-.61,2.54-2.24,2.64-1.83,3.46,21.14,18.7,21.14,18.7,1,6.81,1.93,8.53-1,25.51-3.05,27.14,13.72,1.47,13.72,1.47.71-15.6,1.32-16.41-.41-17.48-.41-17.48-.1-14.23,1.22-18,1.18-16.26,1.18-16.26,1.16-7.5,2.58-9.25S463.16,589.91,463.16,589.91Z",
  transform: "translate(-36.6 -133.2)",
  fill: "#3f3d56"
});

var _ref84 =
/*#__PURE__*/
React.createElement("path", {
  d: "M462.08,581.3a20.38,20.38,0,0,1,1.18,6.86A23.28,23.28,0,0,0,490,577.6a57.52,57.52,0,0,1-1-7.58S457.71,568.39,462.08,581.3Z",
  transform: "translate(-36.6 -133.2)",
  opacity: 0.1
});

var _ref85 =
/*#__PURE__*/
React.createElement("path", {
  d: "M446.64,565.24a23.22,23.22,0,1,0,.5-4.84A23.27,23.27,0,0,0,446.64,565.24Z",
  transform: "translate(-36.6 -133.2)",
  fill: "#ee8e9e"
});

var _ref86 =
/*#__PURE__*/
React.createElement("path", {
  d: "M431.7,619.11l-5.59,1.73a2.88,2.88,0,0,1-1.12,3,3.39,3.39,0,0,0-1.42,3s-.61,2.24-2,2.75-2.33,3.86-2.33,3.86l-4.68,5.39s-1.73,1.42-1.42,2.13-1.83.91-1.83.91l1.12,18.1,9.65,1.82,6-.61,4.88-1.82,4.27-2.55,1.93-5,8.53-13Z",
  transform: "translate(-36.6 -133.2)",
  fill: "#3f3d56"
});

var _ref87 =
/*#__PURE__*/
React.createElement("path", {
  d: "M412.69,643.4s-12.4-17.89-21.65-8.23,3.76,25.3,6.81,24.79,17.59-1.32,17.59-1.32Z",
  transform: "translate(-36.6 -133.2)",
  fill: "#ee8e9e"
});

var _ref88 =
/*#__PURE__*/
React.createElement("path", {
  d: "M447.14,560.4a2.82,2.82,0,0,1,1.71.77c.78.83.82,2.3,1.85,2.82a2.16,2.16,0,0,0,1.21.14c2.7-.39,4.26-3.44,6.86-4.28a7,7,0,0,1,4.55.39,3.46,3.46,0,0,1,1.5,1c.87,1.13.26,2.78.66,4.14.56,1.89,2.81,2.64,4.77,2.88s4.15.39,5.45,1.86a5,5,0,0,1,1,3.93,3.14,3.14,0,0,0,0,1.46c.54,1.52,3.18,1.3,3.87.09.5-.87.35-1.6,1.53-1.84a5,5,0,0,1,2.49.43,18.11,18.11,0,0,0,6.44,1,23.28,23.28,0,1,0-43.84-14.74Z",
  transform: "translate(-36.6 -133.2)",
  opacity: 0.1
});

var _ref89 =
/*#__PURE__*/
React.createElement("path", {
  d: "M476.65,574.87a3.14,3.14,0,0,1,0-1.46,5,5,0,0,0-1-3.93c-1.3-1.47-3.5-1.61-5.45-1.86s-4.21-1-4.77-2.88c-.4-1.36.21-3-.66-4.14a3.35,3.35,0,0,0-1.5-1,7,7,0,0,0-4.55-.4c-2.6.84-4.16,3.89-6.86,4.28a2.17,2.17,0,0,1-1.21-.14c-1-.52-1.07-2-1.85-2.82-1.24-1.31-3.58-.47-5.09-1.44a4.63,4.63,0,0,1-1.64-3,14.57,14.57,0,0,1-.45-6.74c.88-3.78,4.26-6.37,6.42-9.6,2-3,3.14-6.81,6.16-8.81s6.9-1.54,10.31-.53a28.86,28.86,0,0,0,4.83,1.27c2.74.34,5.5-.41,8.27-.5a17.72,17.72,0,0,1,10.92,3.32,6,6,0,0,1,1.78,1.8,9.08,9.08,0,0,1,.8,3.24,16.44,16.44,0,0,0,2.14,5.94c.86,1.43,1.93,2.73,2.7,4.21a6.43,6.43,0,0,1,.73,4.81c-.26.84-.77,1.59-1,2.45-.45,2,.86,3.88,1.75,5.71a10.78,10.78,0,0,1,1.19,5.42,6.84,6.84,0,0,1-2.44,4.87,8.72,8.72,0,0,1-5.15,1.56,18.33,18.33,0,0,1-6.57-1,5,5,0,0,0-2.48-.43c-1.19.24-1,1-1.54,1.84C479.83,576.17,477.19,576.39,476.65,574.87Z",
  transform: "translate(-36.6 -133.2)",
  fill: "#3f3d56"
});

var _ref90 =
/*#__PURE__*/
React.createElement("path", {
  d: "M464.12,706.1l13.11-10.26,20.63-20.33-6.81-.3a4.44,4.44,0,0,0-1.44,2.77c-.1,2.49-5.57.18-8.42,1.6S464.42,698.82,462,698.7s-4.37-1.23-5.38.49l-.08.12a2.89,2.89,0,0,1-1.55.92Z",
  transform: "translate(-36.6 -133.2)",
  opacity: 0.1
});

var _ref91 =
/*#__PURE__*/
React.createElement("path", {
  d: "M437.69,705.39l6.59,21,1,3.3,3.14-.86,6.92-1.9,30.8-8.46a26.72,26.72,0,0,0,11.09-3,33.53,33.53,0,0,1,19.14-4.18c4.07.38,8.6-1.37,12.36-8.32,0,0,8.53-25.2-13-32.41s-22.58,3.83-22.58,3.83l-.29.18c-.84.53-3.18,2.21-3.27,4.25-.1,2.48-5.57.17-8.42,1.59S464.42,699.73,462,699.62s-4.37-1.24-5.38.49a1,1,0,0,1-.08.11c-.75,1-3,1.28-4.51,1.32-.82,0-1.41,0-1.41,0l-.19.06-1.56.46Z",
  transform: "translate(-36.6 -133.2)",
  fill: "#65617d"
});

var _ref92 =
/*#__PURE__*/
React.createElement("path", {
  d: "M439.4,664.54l3.17.51,1.32-13.11s-1.45-.22-3.27-.64C441.1,653.12,440,660.2,439.4,664.54Z",
  transform: "translate(-36.6 -133.2)",
  opacity: 0.1
});

var _ref93 =
/*#__PURE__*/
React.createElement("path", {
  d: "M522.5,603.28s9.45-2.74,7.12,24.09-19.82,43.8-19.82,43.8-20.13,8.84-29.17,7.42S465,676.86,465,676.86a23.13,23.13,0,0,0-9.15-2.44c-5.08-.2-15.75-3.35-16-4.37s2.65-15.95,1.43-17.07c0,0,14.23.58,15.65,1.61s3.45.29,5,0,6.2-4.35,15.45-.8c0,0,3.15.31,4.37-.51a4.38,4.38,0,0,1,3.18-.2,8.74,8.74,0,0,0,2.2-1.12c.31-.4,2.75,0,2.75,0a1.08,1.08,0,0,0,1.52-.71,6.66,6.66,0,0,1,1.42-2.23s2.75-15.45,7.93-21.24a3.32,3.32,0,0,0,1.12-2.95C501.46,623.2,510.3,600,522.5,603.28Z",
  transform: "translate(-36.6 -133.2)",
  opacity: 0.1
});

var _ref94 =
/*#__PURE__*/
React.createElement("path", {
  d: "M448.85,702.05l13.42,16.25.09-.1c.1-.3,1.42-3.76,1.11-4s-2.64-5.29-7.32-7.42a13.93,13.93,0,0,1-5.74-5.23Z",
  transform: "translate(-36.6 -133.2)",
  opacity: 0.1
});

var _ref95 =
/*#__PURE__*/
React.createElement("path", {
  d: "M449,730.16l1.47.84s3.4-2.73,6.79-5.48,6.68-5.44,6.73-5.59c.1-.31,1.42-3.76,1.11-4-.16-.1-.85-1.51-2.14-3.14-9.1-2.55-3.3,3.77-2.53,4.06,0,0-11.08-2.54-11.69,9.52A14.4,14.4,0,0,0,449,730.16Z",
  transform: "translate(-36.6 -133.2)",
  opacity: 0.1
});

var _ref96 =
/*#__PURE__*/
React.createElement("path", {
  d: "M460.25,735.27l1.94,1.12,19.61.51a39.61,39.61,0,0,0,6.94,3.34,6.44,6.44,0,0,0,1,.22,45.73,45.73,0,0,0,5.47.1c1.5,0,2.66-.1,2.66-.1s-.93-24.74-1.63-27.34c-.33-1.25-2-1-3.6-.35a23.21,23.21,0,0,0-3.51,1.78s-8.33.8-9.66,1.52-5.08-.41-7.42,0-6.5-2.75-6.5-2.75c-11.38-3.76-5,3.25-4.17,3.56,0,0-11.07-2.54-11.68,9.52S460.25,735.27,460.25,735.27Z",
  transform: "translate(-36.6 -133.2)",
  fill: "#3f3d56"
});

var _ref97 =
/*#__PURE__*/
React.createElement("path", {
  d: "M488.61,725.72c.21,5.12,4.2,11.48,6.59,14.84,1.5,0,2.66-.1,2.66-.1s-.93-24.74-1.63-27.34c-.33-1.25-2-1-3.6-.35C490.66,716.46,488.44,721.59,488.61,725.72Z",
  transform: "translate(-36.6 -133.2)",
  fill: "#565387"
});

var _ref98 =
/*#__PURE__*/
React.createElement("path", {
  d: "M488.61,725.72c.21,5.12,4.2,11.48,6.59,14.84,1.5,0,2.66-.1,2.66-.1s-.93-24.74-1.63-27.34c-.33-1.25-2-1-3.6-.35C490.66,716.46,488.44,721.59,488.61,725.72Z",
  transform: "translate(-36.6 -133.2)",
  opacity: 0.1
});

var _ref99 =
/*#__PURE__*/
React.createElement("path", {
  d: "M485.26,726.4c1.35,4.94,1.33,10.49,3.48,13.84a6.44,6.44,0,0,0,1,.22,45.73,45.73,0,0,0,5.47.1c1.5,0,2.66-.1,2.66-.1s-.93-24.74-1.63-27.34c-.33-1.25-2-1-3.6-.35a23.21,23.21,0,0,0-3.51,1.78S483.53,720.07,485.26,726.4Z",
  transform: "translate(-36.6 -133.2)",
  opacity: 0.05
});

var _ref100 =
/*#__PURE__*/
React.createElement("path", {
  d: "M417.59,676.26s9.74,3.16,18,14.39Z",
  transform: "translate(-36.6 -133.2)",
  opacity: 0.1
});

var _ref101 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.1
}, React.createElement("path", {
  d: "M496.76,554.3l-.06.22a6.85,6.85,0,0,1-.34.85A6,6,0,0,1,496.76,554.3Z",
  transform: "translate(-36.6 -133.2)"
}), React.createElement("path", {
  d: "M441.64,549.37a9.14,9.14,0,0,1,.75-2c-.05.17-.1.35-.14.53a14.58,14.58,0,0,0,.45,6.74,4.63,4.63,0,0,0,1.64,3c1.51,1,3.85.13,5.08,1.43.79.83.83,2.31,1.85,2.82a2,2,0,0,0,1.22.14c2.7-.38,4.26-3.43,6.86-4.27a6.86,6.86,0,0,1,4.54.39,3.35,3.35,0,0,1,1.51,1c.87,1.12.26,2.78.66,4.14.56,1.88,2.81,2.63,4.76,2.88s4.15.38,5.46,1.86a4.92,4.92,0,0,1,1,3.93,3.23,3.23,0,0,0,0,1.45c.54,1.53,3.18,1.3,3.87.1.5-.88.35-1.6,1.53-1.85a5.1,5.1,0,0,1,2.49.43,18.31,18.31,0,0,0,6.57,1,8.86,8.86,0,0,0,5.15-1.56,6.15,6.15,0,0,0,1.58-1.93,6.5,6.5,0,0,1-2.19,3.45,8.72,8.72,0,0,1-5.15,1.56,18.3,18.3,0,0,1-6.57-1,5,5,0,0,0-2.49-.43c-1.18.24-1,1-1.53,1.84-.69,1.21-3.33,1.43-3.87-.09a3.27,3.27,0,0,1,0-1.46,4.92,4.92,0,0,0-1-3.93c-1.31-1.47-3.5-1.61-5.46-1.86s-4.2-1-4.76-2.88c-.4-1.36.21-3-.66-4.14a3.35,3.35,0,0,0-1.5-1,7,7,0,0,0-4.55-.4c-2.6.84-4.16,3.89-6.86,4.28a2.2,2.2,0,0,1-1.22-.14c-1-.52-1.06-2-1.85-2.82-1.23-1.31-3.57-.47-5.08-1.44a4.63,4.63,0,0,1-1.64-3A14.57,14.57,0,0,1,441.64,549.37Z",
  transform: "translate(-36.6 -133.2)"
}));

var _ref102 =
/*#__PURE__*/
React.createElement("path", {
  d: "M498.33,630.72c-1.86,2.51-4,4.84-5.63,7.5a14.23,14.23,0,0,0-2.47,8.87c1.7-1.75,2.48-4.17,3.56-6.36,1.82-3.72,4.54-6.87,6.83-10.28.44-.65,3.25-4.42,1.83-4.6C501.28,625.7,499,629.86,498.33,630.72Z",
  transform: "translate(-36.6 -133.2)",
  opacity: 0.1
});

var _ref103 =
/*#__PURE__*/
React.createElement("path", {
  d: "M446.88,589.68l20.37,38.52c.61,1.14-1.05,3.21-3.7,4.62L361.88,686.59c-2.65,1.4-5.3,1.61-5.9.46l-20.37-38.51c-.61-1.15.92-3.46,3.57-4.86l101.67-53.77C443.51,588.5,446.28,588.53,446.88,589.68Z",
  transform: "translate(-36.6 -133.2)",
  fill: "#fff"
});

var _ref104 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.2
}, React.createElement("path", {
  d: "M446.88,589.68l20.37,38.52c.61,1.14-1.05,3.21-3.7,4.62L361.88,686.59c-2.65,1.4-5.3,1.61-5.9.46l-20.37-38.51c-.61-1.15.92-3.46,3.57-4.86l101.67-53.77C443.51,588.5,446.28,588.53,446.88,589.68Z",
  transform: "translate(-36.6 -133.2)",
  fill: "#fd8d68"
}));

var _ref105 =
/*#__PURE__*/
React.createElement("rect", {
  x: 387.51,
  y: 620.03,
  width: 59.91,
  height: 2.11,
  transform: "translate(-278.54 134.04) rotate(-27.87)",
  fill: "#fd8d68"
});

var _ref106 =
/*#__PURE__*/
React.createElement("rect", {
  x: 389.92,
  y: 624.59,
  width: 59.91,
  height: 2.11,
  transform: "translate(-280.39 135.7) rotate(-27.87)",
  fill: "#fd8d68",
  opacity: 0.2
});

var _ref107 =
/*#__PURE__*/
React.createElement("rect", {
  x: 392.33,
  y: 629.14,
  width: 59.91,
  height: 2.11,
  transform: "translate(-282.24 137.35) rotate(-27.87)",
  fill: "#fd8d68",
  opacity: 0.2
});

var _ref108 =
/*#__PURE__*/
React.createElement("rect", {
  x: 394.74,
  y: 633.7,
  width: 59.91,
  height: 2.11,
  transform: "translate(-284.09 139.01) rotate(-27.87)",
  fill: "#fd8d68",
  opacity: 0.2
});

var _ref109 =
/*#__PURE__*/
React.createElement("path", {
  d: "M361.53,644.22a14.2,14.2,0,0,0,5.26,26.69l-1.12-2.12a3.23,3.23,0,0,1,1-4.16,5.63,5.63,0,0,0,8.74-4.62,3.24,3.24,0,0,1,4,1.5l1.15,2.18a14.2,14.2,0,0,0-19.05-19.47Zm13.63,12.41a.76.76,0,0,1-.05.3.84.84,0,0,1-.3.32l-.25.14a5.64,5.64,0,1,1-11.16,1h-.07a1.89,1.89,0,0,1-1.05-2.4,3.61,3.61,0,0,1,.83-.92,5.21,5.21,0,0,0,1.56-3.38,6,6,0,0,1,.37.77,1.26,1.26,0,0,1,1.54-.89,4.22,4.22,0,0,0,.72.27,1.64,1.64,0,0,0,.65-.13l1.33-.51a2,2,0,0,1,2.62.36,14.5,14.5,0,0,1,2.22,2.21A4.79,4.79,0,0,1,375.16,656.63Z",
  transform: "translate(-36.6 -133.2)",
  fill: "#fd8d68",
  opacity: 0.2
});

var _ref110 =
/*#__PURE__*/
React.createElement("path", {
  d: "M404.66,647.16c-.1,13.41,27.65,16.26,27.65,16.26l7.09,1.12,3.17.51,1.32-13.11s-1.45-.22-3.27-.64c-2.68-.63-6.16-1.71-6.89-3.23C432.51,645.53,404.76,633.74,404.66,647.16Z",
  transform: "translate(-36.6 -133.2)",
  fill: "#ee8e9e"
});

var _ref111 =
/*#__PURE__*/
React.createElement("path", {
  d: "M522.25,601.22s9.45-2.74,7.12,24.09-19.82,43.8-19.82,43.8-20.13,8.84-29.17,7.42-15.65-1.73-15.65-1.73a23.13,23.13,0,0,0-9.15-2.44c-5.08-.2-15.75-3.35-16-4.37s2.65-16,1.43-17.07c0,0,14.23.58,15.65,1.61s3.45.29,5,0,6.2-4.36,15.45-.8c0,0,3.15.31,4.37-.51a4.38,4.38,0,0,1,3.18-.2,8.74,8.74,0,0,0,2.2-1.12c.31-.4,2.75,0,2.75,0a1.07,1.07,0,0,0,1.52-.71,6.76,6.76,0,0,1,1.42-2.24s2.75-15.44,7.93-21.24a3.29,3.29,0,0,0,1.12-2.94C501.21,621.14,510.06,598,522.25,601.22Z",
  transform: "translate(-36.6 -133.2)",
  fill: "#3f3d56"
});

var _ref112 =
/*#__PURE__*/
React.createElement("path", {
  d: "M914.76,269.34v56c0,1.67-3.12,3-7,3H760c-3.86,0-7-1.35-7-3v-56c0-1.67,3.12-3.37,7-3.37H907.78C911.64,266,914.76,267.67,914.76,269.34Z",
  transform: "translate(-36.6 -133.2)",
  fill: "#fff"
});

var _ref113 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.1
}, React.createElement("path", {
  d: "M897.45,279.53v56c0,1.66-3.13,3-7,3H742.72c-3.86,0-7-1.36-7-3v-56c0-1.67,3.12-3.37,7-3.37H890.47C894.32,276.16,897.45,277.86,897.45,279.53Z",
  transform: "translate(-36.6 -133.2)",
  fill: "#fd8d68"
}));

var _ref114 =
/*#__PURE__*/
React.createElement("path", {
  d: "M914.76,269.34v56c0,1.67-3.12,3-7,3H760c-3.86,0-7-1.35-7-3v-56c0-1.67,3.12-3.37,7-3.37H907.78C911.64,266,914.76,267.67,914.76,269.34Z",
  transform: "translate(-36.6 -133.2)",
  fill: "#fff"
});

var _ref115 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.2
}, React.createElement("path", {
  d: "M914.76,269.34v56c0,1.67-3.12,3-7,3H760c-3.86,0-7-1.35-7-3v-56c0-1.67,3.12-3.37,7-3.37H907.78C911.64,266,914.76,267.67,914.76,269.34Z",
  transform: "translate(-36.6 -133.2)",
  fill: "#fd8d68"
}));

var _ref116 =
/*#__PURE__*/
React.createElement("rect", {
  x: 787.42,
  y: 152.77,
  width: 76.96,
  height: 2.72,
  fill: "#fd8d68"
});

var _ref117 =
/*#__PURE__*/
React.createElement("rect", {
  x: 787.42,
  y: 159.39,
  width: 76.96,
  height: 2.72,
  fill: "#fd8d68",
  opacity: 0.2
});

var _ref118 =
/*#__PURE__*/
React.createElement("rect", {
  x: 787.42,
  y: 166.01,
  width: 76.96,
  height: 2.72,
  fill: "#fd8d68",
  opacity: 0.2
});

var _ref119 =
/*#__PURE__*/
React.createElement("rect", {
  x: 787.42,
  y: 172.63,
  width: 76.96,
  height: 2.72,
  fill: "#fd8d68",
  opacity: 0.2
});

var _ref120 =
/*#__PURE__*/
React.createElement("path", {
  d: "M785.09,280A18.25,18.25,0,0,0,775,313.48v-3.09a4.16,4.16,0,0,1,3.65-4.11,7.24,7.24,0,0,0,12.7,0,4.16,4.16,0,0,1,3.65,4.11v3.17A18.25,18.25,0,0,0,785.09,280Zm8,22.27a.79.79,0,0,1-.77.49,2.3,2.3,0,0,1-.37,0,7.24,7.24,0,0,1-14.18-2.06,7.16,7.16,0,0,1,.94-3.56l-.08-.05a2.42,2.42,0,0,1,.24-3.35,4.91,4.91,0,0,1,1.5-.55,6.65,6.65,0,0,0,3.8-2.9,6.79,6.79,0,0,1,0,1.1,1.61,1.61,0,0,1,2.29-.08c.23.23.38.55.66.73a1.73,1.73,0,0,0,.81.23l1.81.24a2.56,2.56,0,0,1,2.76,2,17.51,17.51,0,0,1,1.19,3.85A6.08,6.08,0,0,1,793.11,302.28Z",
  transform: "translate(-36.6 -133.2)",
  fill: "#fd8d68",
  opacity: 0.2
});

var _ref121 =
/*#__PURE__*/
React.createElement("path", {
  d: "M961.57,727.42c-1.38-5-2.28-9.38-2.28-9.38s.06-5.49-2.56-9.51l-.05-1.37h0L956.28,697a34.22,34.22,0,0,1,2.36-5.4c1.7-3.25-.57-14.85-.57-14.85s-7.4-16.19-6.15-26.68-15.67-45.79-15.67-45.79A46,46,0,0,1,937.32,594a8.18,8.18,0,0,0,.11-2.16,2.26,2.26,0,0,0,0-.26s0,0,0,.08c-.5-6.87-6.43-19.55-6.43-19.55l-.22-24.61s2.92-14.63-3.5-33.86c-2.24-6.71-3.71-12.1-4.67-16.26-.11-.47-.22-.92-.31-1.36,11.59-2.22,20.43-4,20.43-4s-7.84-28-12.6-32.8-9-20.19-9-20.19-3.14-19.89.47-25.87S925.35,397,925.35,397s8.52-6.71,9.51-9.58,2.57-9.31,2.44-12.66-1.34-6.33-1-8.11-2.89-8.39-1.55-11.63a8.62,8.62,0,0,0,.47-3.09v-.13a43.13,43.13,0,0,0-1.09-8.26,23.54,23.54,0,0,0-8.86-4.31l-.22-.75-.57-2c-.3-.18-.59-.34-.88-.48l0-.72-.19-2.87,1.12-6.51c2.27-11.33-12.78-12.43-12.78-12.43a7.82,7.82,0,0,0-4.38-3.55c-3.06-1,.14,16.91,1.6,18,1.09.82,4.58,6.32,6.26,9h0l.28.44a6.82,6.82,0,0,0-.66.75l.72,3.87.11.6a15.68,15.68,0,0,0-2.23,4.16s2.85,2.9,2.43,6.28,1.13,7.52,1.21,7.74c-.17-.18-2.18-2.19-4.08-1.6s-7.23,2.4-7.23,2.4-4,.86-3.59,1.73-2.55,4.88-2.55,4.88l-11.2-9.82c-.12-.3-.24-.6-.35-.91a25.63,25.63,0,0,1-1.11-4.45,24.33,24.33,0,0,0,3.41-1.23,7.47,7.47,0,0,0,2.92-2c1-1.33,1.18-3.1,1.56-4.72.73-3.18,2.46-6.05,3.66-9.09A29.07,29.07,0,0,0,900,319.89a10.66,10.66,0,0,0-1.84-4.63c-1.86-2.36-5.09-3.23-7.49-5.07s-4-4.74-6.78-6.09c-2.5-1.22-5.48-1-8.22-.39a43.87,43.87,0,0,0-15.1,6.15c-1.53,1-3.22,2.14-5,1.88-1.56-.22-2.74-1.42-3.79-2.57a.83.83,0,0,1,0-.15l-.13-.13a19.09,19.09,0,0,0-1.36,8.14c0,.43,0,.86.1,1.29,0,.15,0,.3,0,.45a2.41,2.41,0,0,1,0,.38v0a2.29,2.29,0,0,1-.06.58,4.16,4.16,0,0,1-1,1.49,9,9,0,0,0-.84,1.24c0-.15.08-.3.13-.45a6.32,6.32,0,0,0-1,3.45,3.4,3.4,0,0,0,.9,2.41,11.76,11.76,0,0,0,1.82,1.35,19.53,19.53,0,0,0-.19,3.6,20.91,20.91,0,0,0,10.86,17.43c.14.3.27.6.41.91,1.52,3.58,2.72,7.77,2.41,11.7,0,.29-.06.58-.1.86s-.26.31-.37.47h0s-17.83.86-22.17-2.78-10.24,9.69-10.24,9.69-6.34,1.49-7.67.3-8.78.16-8.78.16a16.08,16.08,0,0,0-11.29-3.64,33.09,33.09,0,0,0-8.36-4.23h0l-.21-.06h0a9.18,9.18,0,0,0-4-.36s-9.05-6.91-11.76-10.7-15.44-17.75-15.5-17.82l-.07-.69-.22-2.1a7.55,7.55,0,0,1-1.09.14l-.27-.72a38.49,38.49,0,0,0-2.82-5.84s-.1-2.66.65-3.35-.72-10.38-.72-10.38-8.61-18.17-15.16-4.1c0,0-13,9.44-1.41,19.39,0,0,4.57,2,5.27,3.7.46,1.1,2.1,4.16,3.2,6.19.18.34.35.64.49.91l-.12.11.23,1.73.09.67c-2.06,1.28-3.45,2.53-3.07,3.42a19.33,19.33,0,0,1,1.46,4.72s16.28,18.85,18.61,27.09c0,0,42.6,23.15,56.37,24.39L823,412.47a98.66,98.66,0,0,0-.16,10.1c.28,2.65-1.08,14.74-1.08,14.74s-1.7,17.77-3.61,20.33S817,470.78,817,470.78a89.34,89.34,0,0,1-2.16,15.14c-1.75,6.79,0,15.05,0,15.05s-6.33,16.18,9.88,4.75c0,0,8.14-.82,17.52-1.5,0,.31,0,.62,0,.94,0,1.21.06,2.52.1,3.9.22,9.12.65,21.68,1.43,31.17C845.16,557,851.55,590,851.55,590l.64,16.7a22.94,22.94,0,0,0-.29,4.79A31,31,0,0,0,857,628.08l1.71,11.08s3.28,7.23,3.51,11.61a6,6,0,0,1-.09,1.07,7.4,7.4,0,0,0-.08,1.71c0,5.06,3.54,17.05,3.54,17.05s.65,12.19,2.5,12.83c1.59.54-1.81,7.11-2.83,9a3.59,3.59,0,0,1-.08-.35c-.13.25-.21.38-.21.38a8.69,8.69,0,0,0-.45,3.11,4.42,4.42,0,0,0,2.19,4.21c3.55,2,5.48,3.68,2.57,4.5a31,31,0,0,0-3.2.81c0-.14-.12-.28-.17-.41a2,2,0,0,0-1.12,2.18,9.2,9.2,0,0,0,1.25,4.1c3.18,6.43,5.3,8.83,5.3,8.83l1.39-.21a7.27,7.27,0,0,1-.75,1.54,5.93,5.93,0,0,1-2,1.91,6.31,6.31,0,0,1-2.46,1,7,7,0,0,0-5.08,2.72c-1.73,2.42-2.75,5.68,1,8.36l13.24,4s22.58,2.06,21.19-2.94-2.28-9.38-2.28-9.38a20,20,0,0,0-2.17-8.87,11,11,0,0,0-.84-1.29l.79-.12s1.21-11.2,3.32-13.41c.49-.5.59-.88.46-1.17.2-.62-.38-1-1.13-1.12,0,.14-.09.29-.14.44a11.21,11.21,0,0,0-2.19-.16s-1-5.8,1.34-8a2.24,2.24,0,0,0,.39-1.75,9.47,9.47,0,0,0-.34-2.36.61.61,0,0,0-.07.14c-1.41-5.25-5.78-13.51-5.78-13.51s-.38-5.3,1-7.47-1.3-28.82-1.3-28.82.06-12.93-1.82-18.87,1.51-13.16,1.51-13.16,0-.14-.06-.39l0-.09s-.11-.79-.29-2a.65.65,0,0,1,0,.13c-.49-3.4-1.43-9.56-2-12.41-.89-4-.72-23.52-.72-23.52l3-8.44,6.4,14.1,6.95,18.86s3.23,3.91,3.46,8c0,.2,0,.4,0,.6a11,11,0,0,0,0,1.28,11.38,11.38,0,0,0,2.15,6.72s2,9,4.64,11.16,2.82,6.62,2.82,6.62,3.61,13,5.16,15.21c1.3,1.89,1.57,7.21,1.62,8.84h0c0,.3,0,.48,0,.48s.62,4.66.75,8.59c0,.48,0,1,0,1.4,0,0,0-.07,0-.1a14.23,14.23,0,0,1-.26,3.19c0,.06,0,.12,0,.19q0-.35,0-.66a33.61,33.61,0,0,0-.62,8.18c.1,4.71,1,10.25,4,13.41,5.15,5.47,8.23,4.64,8.23,4.64s-2.1,7.16-5,8.69a2.11,2.11,0,0,0-.31.21c0-.13-.06-.27-.08-.4a3.42,3.42,0,0,0-.76,2.66c-.09,3.12,2.07,8.1,4,10.35a5.82,5.82,0,0,0,2.52,1.34,4.91,4.91,0,0,1-.44.31,9.45,9.45,0,0,1-1,.51,4.9,4.9,0,0,1-1.48.44,7.05,7.05,0,0,0-5.08,2.72c-1.72,2.42-2.75,5.67,1,8.36l13.24,4S963,732.42,961.57,727.42Z",
  transform: "translate(-36.6 -133.2)",
  fill: "url(#ffba99e4-d350-4cb7-a6ec-0715674198cb)"
});

var _ref122 =
/*#__PURE__*/
React.createElement("path", {
  d: "M876.07,739.07l-12.82-4c-3.59-2.69-2.6-5.95-.93-8.37a6.75,6.75,0,0,1,4.91-2.71,6,6,0,0,0,2.38-1,5.6,5.6,0,0,0,1.93-1.91,9.36,9.36,0,0,0,1.26-4.94s13.72-4.6,17.68-.68a10.68,10.68,0,0,1,1.78,2.4,20.65,20.65,0,0,1,2.11,8.88s.88,4.38,2.22,9.38S876.07,739.07,876.07,739.07Z",
  transform: "translate(-36.6 -133.2)",
  fill: "#2d293d"
});

var _ref123 =
/*#__PURE__*/
React.createElement("path", {
  d: "M937.71,730.46l-12.81-4c-3.6-2.68-2.61-5.94-.94-8.35a6.68,6.68,0,0,1,4.91-2.71,5,5,0,0,0,1.43-.45,8.26,8.26,0,0,0,1-.51c3.47-2.08,3.19-6.85,3.19-6.85s13.73-4.6,17.68-.68a9.78,9.78,0,0,1,1.4,1.75c2.54,4,2.49,9.52,2.49,9.52s.88,4.4,2.22,9.39S937.71,730.46,937.71,730.46Z",
  transform: "translate(-36.6 -133.2)",
  fill: "#2d293d"
});

var _ref124 =
/*#__PURE__*/
React.createElement("path", {
  d: "M890.48,715.5a10.68,10.68,0,0,1,1.78,2.4h0l-20.72,3.21a9.36,9.36,0,0,0,1.26-4.94S886.52,711.58,890.48,715.5Z",
  transform: "translate(-36.6 -133.2)",
  opacity: 0.1
});

var _ref125 =
/*#__PURE__*/
React.createElement("path", {
  d: "M953.52,708.64l.15,3.9c-3,5.46-18.72,4.89-23.37,2.39a8.26,8.26,0,0,0,1-.51c3.47-2.08,3.19-6.85,3.19-6.85s13.73-4.6,17.68-.68A9.78,9.78,0,0,1,953.52,708.64Z",
  transform: "translate(-36.6 -133.2)",
  opacity: 0.1
});

var _ref126 =
/*#__PURE__*/
React.createElement("path", {
  d: "M955.35,691.76a34.32,34.32,0,0,0-2.27,5.4l.53,14c-3.31,6-21.77,4.74-24.37,1.65s-5.57-11.29-2.79-12.82,4.8-8.68,4.8-8.68-3,.82-8-4.65-4.06-18.08-3.29-21.12-.51-13.09-.51-13.09-.09-7.08-1.59-9.32-5-15.21-5-15.21-.17-4.42-2.73-6.63-4.5-11.16-4.5-11.16a11.6,11.6,0,0,1-2.06-7.53c.36-4.44-3.36-9.08-3.36-9.08l-6.75-18.86-6.21-14.11L884.4,569s-.14,19.48.73,23.52,2.34,14.78,2.34,14.78-3.27,7.21-1.44,13.16,1.79,18.88,1.79,18.88,2.61,26.63,1.28,28.81-1,7.47-1,7.47,7.85,15.28,5.63,17.49-1.29,8-1.29,8,5-.19,2.92,2-3.21,13.41-3.21,13.41l-21.28,3.3s-2.06-2.4-5.14-8.84.31-5.85,3.13-6.67,1-2.51-2.49-4.51-1.68-6.84-1.68-6.84,4.79-8.86,3-9.5-2.44-12.83-2.44-12.83-4.09-14.36-3.36-18.29-3.34-13.15-3.34-13.15l-1.66-11.09a30.64,30.64,0,0,1-4.7-20.89L851.57,590s-6.23-33-7.58-49.82c-.87-10.74-1.31-25.42-1.51-34.59-.11-5.14-.15-8.55-.15-8.55l76.07-10.89a63.52,63.52,0,0,0,1.82,11.29c.94,4.16,2.37,9.55,4.55,16.26,6.23,19.24,3.43,33.87,3.43,33.87l.24,24.6s7.35,16.18,6.15,21.9a47.55,47.55,0,0,0-1,10.31s16.41,35.31,15.22,45.8,6,26.69,6,26.69S957,688.51,955.35,691.76Z",
  transform: "translate(-36.6 -133.2)",
  fill: "#65617d"
});

var _ref127 =
/*#__PURE__*/
React.createElement("path", {
  d: "M908.13,601.32l23.13-4S918.61,611.28,908.13,601.32Z",
  transform: "translate(-36.6 -133.2)",
  opacity: 0.05
});

var _ref128 =
/*#__PURE__*/
React.createElement("path", {
  d: "M927,574.74s1.11,8.19-3.81,11.48C923.22,586.22,932.19,584.46,927,574.74Z",
  transform: "translate(-36.6 -133.2)",
  opacity: 0.1
});

var _ref129 =
/*#__PURE__*/
React.createElement("path", {
  d: "M924.6,548.63s-18.82,16.75-26,15.7S924.6,548.63,924.6,548.63Z",
  transform: "translate(-36.6 -133.2)",
  opacity: 0.1
});

var _ref130 =
/*#__PURE__*/
React.createElement("path", {
  d: "M879.6,610s-14.63,3.92-14.84,9.86S879.6,610,879.6,610Z",
  transform: "translate(-36.6 -133.2)",
  opacity: 0.1
});

var _ref131 =
/*#__PURE__*/
React.createElement("path", {
  d: "M885.69,683.55S865,688.24,871,690.66s15.83,4.18,15.83,4.18S893.56,694.93,885.69,683.55Z",
  transform: "translate(-36.6 -133.2)",
  opacity: 0.05
});

var _ref132 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.05
}, React.createElement("path", {
  d: "M867,695a4.15,4.15,0,0,1-2-2.95c-.12.24-.2.38-.2.38s-1.76,4.84,1.68,6.84c.4.23.77.45,1.12.67.62-.14,1.28-.25,1.92-.44C872.26,698.73,870.39,697,867,695Z",
  transform: "translate(-36.6 -133.2)"
}), React.createElement("path", {
  d: "M893.77,692.59c.55-.55.48-1.91.06-3.64a9.82,9.82,0,0,0-1,5.16A4.1,4.1,0,0,1,893.77,692.59Z",
  transform: "translate(-36.6 -133.2)"
}), React.createElement("path", {
  d: "M887.17,604.75a24,24,0,0,0-1.16,6.56,25.51,25.51,0,0,1,1.45-4.53S887.35,606,887.17,604.75Z",
  transform: "translate(-36.6 -133.2)"
}), React.createElement("path", {
  d: "M934.58,593.63a7.86,7.86,0,0,0,.12-1.94c-.21,1.33-.35,2.56-.44,3.64C934.36,594.78,934.46,594.21,934.58,593.63Z",
  transform: "translate(-36.6 -133.2)"
}), React.createElement("path", {
  d: "M889.09,667.62a11.24,11.24,0,0,0,.37-3.94,13.31,13.31,0,0,0-.82,5A4.81,4.81,0,0,1,889.09,667.62Z",
  transform: "translate(-36.6 -133.2)"
}), React.createElement("path", {
  d: "M894.75,700.8a69.59,69.59,0,0,0-2,11l-21.28,3.3s-2.05-2.4-5.13-8.83c-.27-.57-.49-1.08-.67-1.54-1.26.64-1.71,2,.12,5.81,3.08,6.43,5.14,8.83,5.14,8.83l21.28-3.3s1.16-11.2,3.2-13.4C896.4,701.54,895.71,701,894.75,700.8Z",
  transform: "translate(-36.6 -133.2)"
}), React.createElement("path", {
  d: "M865.28,670.13s.65,12.2,2.44,12.84h0c.82-2.05,1.34-4,.54-4.27-1.8-.64-2.44-12.84-2.44-12.84s-4.1-14.36-3.36-18.28-3.34-13.15-3.34-13.15l-1.67-11.09a30.64,30.64,0,0,1-4.7-20.89l-.66-17.15s-6.23-33-7.58-49.82c-.87-10.74-1.31-25.43-1.51-34.59,0-1.66-.06-3.13-.09-4.37l-.61.09s0,3.4.16,8.55c.2,9.16.64,23.85,1.5,34.59,1.36,16.77,7.59,49.82,7.59,49.82l.66,17.15a30.64,30.64,0,0,0,4.7,20.89l1.66,11.09s4.08,9.22,3.34,13.15S865.28,670.13,865.28,670.13Z",
  transform: "translate(-36.6 -133.2)"
}), React.createElement("path", {
  d: "M929.77,708a20.68,20.68,0,0,1-3.7-8.26c-2.11,2,.69,9.6,3.16,12.53,2.6,3.09,21.06,4.33,24.37-1.64l-.13-3.37C948.88,712.2,932.23,710.94,929.77,708Z",
  transform: "translate(-36.6 -133.2)"
}), React.createElement("path", {
  d: "M955.88,687a34.32,34.32,0,0,0-2.27,5.4l.09,2.48c.37-.92.9-2.15,1.64-3.61a10.73,10.73,0,0,0,.6-4.41Z",
  transform: "translate(-36.6 -133.2)"
}), React.createElement("path", {
  d: "M930.2,690.79a33.39,33.39,0,0,0,1.58-4.27s-3,.82-8-4.65c-3.63-4-4.13-11.75-3.83-16.85-.77,3-1.7,15.65,3.29,21.12C926.53,689.72,928.93,690.6,930.2,690.79Z",
  transform: "translate(-36.6 -133.2)"
}), React.createElement("path", {
  d: "M919.47,651.94a96,96,0,0,1,.76,10.46,12.91,12.91,0,0,1,.3-1.65c.77-3-.51-13.08-.51-13.08s-.1-7.08-1.6-9.33-5-15.21-5-15.21-.17-4.42-2.74-6.62-4.5-11.16-4.5-11.16a11.64,11.64,0,0,1-2.06-7.54c.36-4.44-3.36-9.07-3.36-9.07L894,569.87l-6.21-14.1-2.86,8.43s0,1,0,2.69l2.33-6.85,6.21,14.1L900.21,593s3.72,4.63,3.36,9.07a11.58,11.58,0,0,0,2.06,7.54s1.93,9,4.5,11.16,2.73,6.62,2.73,6.62,3.51,13,5,15.21S919.47,651.94,919.47,651.94Z",
  transform: "translate(-36.6 -133.2)"
}));

var _ref133 =
/*#__PURE__*/
React.createElement("path", {
  d: "M921.8,326.07l-1.08,6.51.19,2.87.14,2.12-7.35,1-.89-1.5h0c-1.63-2.71-5-8.22-6.08-9-1.4-1.09-4.53-18.95-1.57-18a7.75,7.75,0,0,1,4.26,3.56S924,314.75,921.8,326.07Z",
  transform: "translate(-36.6 -133.2)",
  fill: "#ffcdd3"
});

var _ref134 =
/*#__PURE__*/
React.createElement("path", {
  d: "M921.05,337.57l-7.35,1-.89-1.5h0a6.52,6.52,0,0,1,8.1-1.66Z",
  transform: "translate(-36.6 -133.2)",
  opacity: 0.1
});

var _ref135 =
/*#__PURE__*/
React.createElement("path", {
  d: "M923,341l-9.64,2.63-.26-1.44-.7-3.88s3.65-5.28,9.37-1.64l.56,2Z",
  transform: "translate(-36.6 -133.2)",
  fill: "#dce6f2"
});

var _ref136 =
/*#__PURE__*/
React.createElement("path", {
  d: "M764.91,332.82l-10.17,6s-.43-.8-1-1.92c-1.07-2-2.66-5.1-3.11-6.2-.68-1.69-5.1-3.7-5.1-3.7-11.27-10,1.34-19.39,1.34-19.39,6.32-14.06,14.67,4.12,14.67,4.12s1.44,9.69.71,10.38-.62,3.34-.62,3.34a39.3,39.3,0,0,1,2.73,5.85C764.72,332.22,764.91,332.82,764.91,332.82Z",
  transform: "translate(-36.6 -133.2)",
  fill: "#ffcdd3"
});

var _ref137 =
/*#__PURE__*/
React.createElement("path", {
  d: "M764.91,332.82l-10.17,6s-.43-.8-1-1.92c1.41-1.28,6.45-5.7,8.16-5.57a13.19,13.19,0,0,0,2.46,0C764.72,332.22,764.91,332.82,764.91,332.82Z",
  transform: "translate(-36.6 -133.2)",
  opacity: 0.1
});

var _ref138 =
/*#__PURE__*/
React.createElement("path", {
  d: "M766.09,335.92l-11.45,6.2-.33-2.5-.23-1.73s6.54-6.05,8.55-5.91a10.82,10.82,0,0,0,3-.12l.22,2.09Z",
  transform: "translate(-36.6 -133.2)",
  fill: "#dce6f2"
});

var _ref139 =
/*#__PURE__*/
React.createElement("path", {
  d: "M895.16,370s-50.66,7.7-41.27,4.25c6.54-2.42,9-6.73,9.38-11.41.29-3.93-.87-8.12-2.35-11.71a51.09,51.09,0,0,0-4.9-9s38.07-22.89,31-3.14a30.94,30.94,0,0,0-1.85,9.3,26,26,0,0,0,1.36,9.29A27.8,27.8,0,0,0,895.16,370Z",
  transform: "translate(-36.6 -133.2)",
  fill: "#ffcdd3"
});

var _ref140 =
/*#__PURE__*/
React.createElement("path", {
  d: "M887.06,339a30.94,30.94,0,0,0-1.85,9.3c-3.54,3.22-7.57,3.17-12.73,3.37-4,.15-8.32,1.28-11.56-.51a51.09,51.09,0,0,0-4.9-9S894.09,319.26,887.06,339Z",
  transform: "translate(-36.6 -133.2)",
  opacity: 0.1
});

var _ref141 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 834.44,
  cy: 198.81,
  r: 21.06,
  fill: "#ffcdd3"
});

var _ref142 =
/*#__PURE__*/
React.createElement("path", {
  d: "M895.16,370s-50.66,7.7-41.27,4.25c6.54-2.42,9-6.73,9.38-11.41,2.43-2.85,7.44-5,10.67-6.2a15.19,15.19,0,0,1,9.21-.5,12.83,12.83,0,0,1,3.42,1.42A27.8,27.8,0,0,0,895.16,370Z",
  transform: "translate(-36.6 -133.2)",
  opacity: 0.1
});

var _ref143 =
/*#__PURE__*/
React.createElement("path", {
  d: "M923,341l-9.64,2.63-.26-1.44a8.62,8.62,0,0,1,9.23-3.56Z",
  transform: "translate(-36.6 -133.2)",
  opacity: 0.1
});

var _ref144 =
/*#__PURE__*/
React.createElement("path", {
  d: "M766.09,335.92l-11.45,6.2-.33-2.5A84.76,84.76,0,0,1,765.89,334Z",
  transform: "translate(-36.6 -133.2)",
  opacity: 0.1
});

var _ref145 =
/*#__PURE__*/
React.createElement("path", {
  d: "M920.22,497.48c-19.58,3.87-47.47,9-52,7.81-3.74-1-15.52-.41-25.77.34-.11-5.14-.15-8.55-.15-8.55l76.07-10.89A63.52,63.52,0,0,0,920.22,497.48Z",
  transform: "translate(-36.6 -133.2)",
  opacity: 0.1
});

var _ref146 =
/*#__PURE__*/
React.createElement("path", {
  d: "M939.7,492.1s-64.46,13.63-71.51,11.78-42.71,1.82-42.71,1.82c-15.67,11.4-9.57-4.77-9.57-4.77s-1.73-8.25,0-15.05a92.45,92.45,0,0,0,2.07-15.13s-.76-10.59,1.09-13.14,3.47-20.32,3.47-20.32,1.3-12.09,1-14.74.15-10.09.15-10.09L825.49,400c-13.33-1.26-54.59-24.46-54.59-24.46-2.27-8.23-18-27.1-18-27.1a20.3,20.3,0,0,0-1.42-4.73c-1.17-2.79,14.53-9.06,14.53-9.06s12.4,14,15,17.84,11.39,10.72,11.39,10.72a8.5,8.5,0,0,1,3.91.35l.2.06h0a31.66,31.66,0,0,1,8.09,4.24,15.36,15.36,0,0,1,10.94,3.65s7.21-1.34,8.49-.15,7.43-.28,7.43-.28,5.68-13.33,9.89-9.68,21.47,2.8,21.47,2.8c2.18-3.14,7.69-5.55,11.15-6.81a15.19,15.19,0,0,1,9.21-.51,11.82,11.82,0,0,1,3.71,1.62l10.86,9.85s2.86-4,2.47-4.88,3.48-1.72,3.48-1.72,5.06-1.79,7-2.4,3.78,1.44,3.95,1.61c-.08-.22-1.57-4.45-1.18-7.74s-2.37-6.28-2.37-6.28c5.61-15.44,20.06-3.25,20.06-3.25s1.92,8.25.62,11.49,1.8,9.84,1.51,11.62.89,4.75,1,8.11-1.39,9.79-2.34,12.66-9.2,9.56-9.2,9.56-.14,10.1-3.63,16.08-.42,25.87-.42,25.87,4.14,15.42,8.75,20.2S939.7,492.1,939.7,492.1Z",
  transform: "translate(-36.6 -133.2)",
  fill: "#3f3d56"
});

var _ref147 =
/*#__PURE__*/
React.createElement("path", {
  d: "M840.63,379.4s-2.17-5.76-4-6.22a42.43,42.43,0,0,1-5.21-2.1l1-2.22s6.71,1.56,7.85,3.47S840.63,379.4,840.63,379.4Z",
  transform: "translate(-36.6 -133.2)",
  opacity: 0.1
});

var _ref148 =
/*#__PURE__*/
React.createElement("path", {
  d: "M804.6,367.86c-.29,1.78-16,4-16,4l7.65-8.29h0l.2.06h0A31.66,31.66,0,0,1,804.6,367.86Z",
  transform: "translate(-36.6 -133.2)",
  opacity: 0.1
});

var _ref149 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 721.54,
  cy: 212.14,
  r: 1.42,
  fill: "#575988"
});

var _ref150 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 723.46,
  cy: 214.9,
  r: 1.42,
  fill: "#575988"
});

var _ref151 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 725.33,
  cy: 217.44,
  r: 1.42,
  fill: "#575988"
});

var _ref152 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 727.29,
  cy: 220.2,
  r: 1.42,
  fill: "#575988"
});

var _ref153 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 893.95,
  cy: 213.63,
  r: 1.15,
  fill: "#575988"
});

var _ref154 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 894.23,
  cy: 216.23,
  r: 1.15,
  fill: "#575988"
});

var _ref155 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 894.48,
  cy: 218.83,
  r: 1.15,
  fill: "#575988"
});

var _ref156 =
/*#__PURE__*/
React.createElement("path", {
  d: "M842.56,427.31c-.17-.2,41.62,48.6,71.45,18.32C914,445.63,865.37,454.14,842.56,427.31Z",
  transform: "translate(-36.6 -133.2)",
  opacity: 0.1
});

var _ref157 =
/*#__PURE__*/
React.createElement("path", {
  d: "M820.67,454.36s23.88-.27,26.64,6.49l.27,7.14a4.55,4.55,0,0,1-4.44.17c-2.45-1.2-17.15-8-22.1-4.25Z",
  transform: "translate(-36.6 -133.2)",
  opacity: 0.1
});

var _ref158 =
/*#__PURE__*/
React.createElement("path", {
  d: "M821.12,454.34s22.83-.26,25.47,6.19l.26,6.81a4.38,4.38,0,0,1-4.25.16c-2.34-1.15-16.4-7.6-21.13-4.05Z",
  transform: "translate(-36.6 -133.2)",
  fill: "#656691"
});

var _ref159 =
/*#__PURE__*/
React.createElement("path", {
  d: "M831.7,402.07a76.72,76.72,0,0,0,9.86,15.51,62.23,62.23,0,0,0,15,13.42S832.22,405.33,831.7,402.07Z",
  transform: "translate(-36.6 -133.2)",
  opacity: 0.1
});

var _ref160 =
/*#__PURE__*/
React.createElement("path", {
  d: "M822.83,374.66s4.64,17,15.12,22.46Z",
  transform: "translate(-36.6 -133.2)",
  opacity: 0.1
});

var _ref161 =
/*#__PURE__*/
React.createElement("path", {
  d: "M816.8,376.63c-.12-.32-3,13.72,14,20.76C830.83,397.39,823.62,395.25,816.8,376.63Z",
  transform: "translate(-36.6 -133.2)",
  opacity: 0.1
});

var _ref162 =
/*#__PURE__*/
React.createElement("path", {
  d: "M920.49,361.1c-.26,0,8.48,5.11,10.89,7.55C931.38,368.65,925.52,360.55,920.49,361.1Z",
  transform: "translate(-36.6 -133.2)",
  opacity: 0.1
});

var _ref163 =
/*#__PURE__*/
React.createElement("path", {
  d: "M866.08,351.3a3.31,3.31,0,0,0,3.75,3.15c6.43.15,13.12.18,19-2.52a7.16,7.16,0,0,0,2.81-2c1-1.33,1.14-3.09,1.51-4.72.71-3.17,2.37-6,3.54-9.08A30.07,30.07,0,0,0,898.11,320a10.74,10.74,0,0,0-1.78-4.63c-1.8-2.37-4.94-3.23-7.26-5.08s-3.89-4.75-6.57-6.1c-2.42-1.22-5.31-1-8-.4a41.76,41.76,0,0,0-14.6,6.14c-1.49,1-3.12,2.13-4.89,1.87-1.55-.23-2.71-1.48-3.75-2.65a19.61,19.61,0,0,0-1.22,9.23,4,4,0,0,1,0,1.38,4.24,4.24,0,0,1-.93,1.49c-1.51,1.9-2.39,4.85-.75,6.64.71.79,1.77,1.19,2.47,2,1.24,1.43.92,3.57,1,5.46a2.77,2.77,0,0,0,.54,1.85,2.73,2.73,0,0,0,2.62.52,7.07,7.07,0,0,1,2.75-.37,4.58,4.58,0,0,1,2.48,1.76C863.35,342.72,864.66,346.82,866.08,351.3Z",
  transform: "translate(-36.6 -133.2)",
  fill: "#2d293d"
});

var _ref164 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.1
}, React.createElement("path", {
  d: "M892.25,348.25a7.17,7.17,0,0,1-2.82,2c-5.84,2.7-12.52,2.68-18.95,2.52a3.31,3.31,0,0,1-3.76-3.14c-1.41-4.49-2.73-8.59-5.84-12.24a4.6,4.6,0,0,0-2.47-1.76,7.31,7.31,0,0,0-2.76.37,2.73,2.73,0,0,1-2.62-.52,2.83,2.83,0,0,1-.54-1.85c0-1.89.28-4-1-5.46-.69-.8-1.76-1.2-2.47-2a4.16,4.16,0,0,1-.57-4.21c-1.05,1.83-1.45,4.14-.08,5.65.71.78,1.78,1.18,2.47,2,1.24,1.43.93,3.57,1,5.47a2.76,2.76,0,0,0,.54,1.84,2.7,2.7,0,0,0,2.62.52,7.28,7.28,0,0,1,2.76-.37,4.65,4.65,0,0,1,2.47,1.76c3.11,3.66,4.42,7.75,5.84,12.24a4.45,4.45,0,0,0,1.75,2.78,4.51,4.51,0,0,0,2,.37c6.43.15,13.12.17,19-2.53a7.25,7.25,0,0,0,2.82-2,5.72,5.72,0,0,0,.84-1.74A2.9,2.9,0,0,1,892.25,348.25Z",
  transform: "translate(-36.6 -133.2)"
}), React.createElement("path", {
  d: "M850.13,319.17a3,3,0,0,0,.6-1.09,3.77,3.77,0,0,0,0-1.38,19.59,19.59,0,0,1,.7-7.65l-.13-.14a19.64,19.64,0,0,0-1.22,9.23A5.94,5.94,0,0,1,850.13,319.17Z",
  transform: "translate(-36.6 -133.2)"
}));

var _ref165 =
/*#__PURE__*/
React.createElement("path", {
  d: "M862.82,364.2s26.42,2.48,28.63-1.57",
  transform: "translate(-36.6 -133.2)",
  opacity: 0.1
});

var _ref166 =
/*#__PURE__*/
React.createElement("path", {
  d: "M913.5,351.36s14.6-.54,18,4.81",
  transform: "translate(-36.6 -133.2)",
  opacity: 0.1
});

var _ref167 =
/*#__PURE__*/
React.createElement("path", {
  d: "M198.31,305.25v56c0,1.67-3.13,3-7,3H43.58c-3.86,0-7-1.35-7-3v-56c0-1.67,3.12-3.37,7-3.37H191.33C195.18,301.88,198.31,303.58,198.31,305.25Z",
  transform: "translate(-36.6 -133.2)",
  fill: "#fff"
});

var _ref168 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.2
}, React.createElement("path", {
  d: "M198.31,305.25v56c0,1.67-3.13,3-7,3H43.58c-3.86,0-7-1.35-7-3v-56c0-1.67,3.12-3.37,7-3.37H191.33C195.18,301.88,198.31,303.58,198.31,305.25Z",
  transform: "translate(-36.6 -133.2)",
  fill: "#fd8d68"
}));

var _ref169 =
/*#__PURE__*/
React.createElement("rect", {
  x: 70.97,
  y: 188.68,
  width: 76.96,
  height: 2.72,
  fill: "#fd8d68"
});

var _ref170 =
/*#__PURE__*/
React.createElement("path", {
  d: "M68.63,315.92a18.25,18.25,0,0,0-10.06,33.47v-1.22a4.14,4.14,0,0,1,3.65-4.1,7.24,7.24,0,0,0,12.7,0,4.14,4.14,0,0,1,3.65,4.1v1.3a18.25,18.25,0,0,0-9.94-33.55Zm7.15,23.13a7.23,7.23,0,0,1-14.42,0,7.92,7.92,0,0,1,4.15-10.61,2.32,2.32,0,0,1-.39-1.3,2.41,2.41,0,0,1,2.42-2.41h.17a2.41,2.41,0,0,0-2.24,2.41,2.31,2.31,0,0,0,.32,1.19l.07,0a2.42,2.42,0,0,1,0-.47,2.39,2.39,0,0,1,.45-1.4,2.41,2.41,0,0,1,2.31-1.7h.17a2.42,2.42,0,0,0-1.84,1.08,2.41,2.41,0,0,1,3.74,2,2.45,2.45,0,0,1,0,.27,7.92,7.92,0,0,1,5.16,10.95Z",
  transform: "translate(-36.6 -133.2)",
  fill: "#fd8d68",
  opacity: 0.2
});

var _ref171 =
/*#__PURE__*/
React.createElement("rect", {
  x: 70.97,
  y: 195.3,
  width: 76.96,
  height: 2.72,
  fill: "#fd8d68",
  opacity: 0.2
});

var _ref172 =
/*#__PURE__*/
React.createElement("rect", {
  x: 70.97,
  y: 201.92,
  width: 76.96,
  height: 2.72,
  fill: "#fd8d68",
  opacity: 0.2
});

var _ref173 =
/*#__PURE__*/
React.createElement("rect", {
  x: 70.97,
  y: 208.54,
  width: 76.96,
  height: 2.72,
  fill: "#fd8d68",
  opacity: 0.2
});

var _ref174 =
/*#__PURE__*/
React.createElement("path", {
  d: "M300,476.46a60.5,60.5,0,0,1-1-9.21c0-3.7-5-7-5-7s-3.11-7.2-5.15-8.25-8.47-10.48-8.47-10.48a8.54,8.54,0,0,0-1.93-5.08,72.79,72.79,0,0,1-5.24-7.91v0c-.86-1.06-.43-1.8-1.72-7.94q-.11-.48-.24-.93c0-.14-.09-.26-.13-.39a10.38,10.38,0,0,0,2.44-10.74,4.41,4.41,0,0,0-1.23-1.9c-1.46-1.19-3.79-.7-5.29-1.83l1.59-7.06c.39-1.72.59-3.92-.93-4.85a7.62,7.62,0,0,0-1.78-.6c-2.62-.83-4.09-3.59-4.76-6.23a21.36,21.36,0,0,1-.52-7.8c.29-2.5,1-4.94,1.3-7.45a20.57,20.57,0,0,0-3.17-13.26,10.34,10.34,0,0,0-4.19-3.95c-1.61-.72-3.48-.81-5-1.76-3.22-2-3.06-6.89-5.62-9.7s-7.11-2.78-10.85-1.82-7.45,2.61-11.29,2.18c-2.47-.27-4.79-1.39-7.26-1.65a7.26,7.26,0,0,0-2.13.1l.05-.09c-1.84.33-3.52,1.35-3.95,3.09a4.77,4.77,0,0,0-.12,1.26c0,1,.24,2.06.26,3a2.92,2.92,0,0,1-.7,2.13c-.49.53-1.22.81-1.7,1.35a2.2,2.2,0,0,0-.63,1.59c0,1.54,1.92,2.89,3.21,3.51l0,0c-.35.35-.69.71-1,1.08A22.72,22.72,0,0,0,202.22,373a23.05,23.05,0,0,0,14,21.11c-.06.19-.11.37-.18.56a29.72,29.72,0,0,1-1.26,3.27,6.48,6.48,0,0,0-5.43.6c-2.47,1.69-7.29,1.59-8.58,1.27s-14.69-2-15.76-1.59-3.22-1.48-4.61,1.06-2,3.92-3.43,4.55-3.86,2.65-3.54,3.07-3.54,3-3.54,3-3.32,3.49-5.25,3.92-6,3.07-6,3.07l-4.72,3.7s-3.54.53-2.47-1.9-1.93-5.51-1.93-5.51-6-12.17-6-14.7-4.93-13.23-4.93-13.23l-.61-.06c-.09-.26-.18-.52-.28-.79-.9-2.55-2.07-5.67-3-7.51C133,373.4,131.9,373,131.9,373s-20.8-15.62-34.31-10.86,24.66,18.94,28.09,20.43c1.2.51,2.06,2.19,2.67,4.14A17.77,17.77,0,0,0,121,393.4s8.25,18.3,8.46,22.85,5.69,17.25,5.69,17.25,2,9.42,13.08,8.89c0,0,15.22,2.79,18.54,0s6.33-5,7.94-5.31a6.25,6.25,0,0,0,3-2.12s-5,31.74-7.5,34.5-24.34,38.41-16.52,44.75a156.79,156.79,0,0,0,19.62,13c.67.33,2.66-3,5.51-5.35,0,.59,0,1.2,0,1.83.05,12.68,1.7,32,4.05,36.32,3.43,6.35,2,18.63,2,18.63a14.8,14.8,0,0,0,5.8,1.39c.1.41.22.84.34,1.29,1.89,7.14,4.95,18.18,6.51,21.12,2.37,4.45,4.08,18.52,4.08,18.52s1.39,13.86.86,15.77c-.21.73.7,6.48,2.12,13.78h0c-.87,9.92-2.5,29.05-2.78,36v0c0,.13,0,.26,0,.39v.35c0,.15,0,.29,0,.42v0a7.86,7.86,0,0,0,0,1.3,4.07,4.07,0,0,1-.14,2,32.13,32.13,0,0,1-2.33,5.54c-.05.18-.63,1.38-1,2.69-.85.37-1.91,1.3-2.5,3.55-1.07,4.13-2.68,15.56-2.68,15.56s-.64,7-1.93,8.57-2.57,11.53,6.54,12.8,13.08-4.84,13.08-4.84l-.32-27.7v0a4,4,0,0,0,.47-.76l0-.06c.06-.14.13-.27.19-.43s0-.13.08-.2.09-.22.13-.34a.56.56,0,0,1,0-.12,18.2,18.2,0,0,0,.77-8.25s0-.09,0-.14l0-.22c0-.07,0-.14,0-.21a1.28,1.28,0,0,0,0-.19,1.93,1.93,0,0,1,0-.24v-.17c0-.18,0-.37.06-.56a.37.37,0,0,1,0-.11c0-.11,0-.22,0-.33a.77.77,0,0,0,0-.15c0-.11.05-.23.07-.35l0-.08c.08-.41.19-.82.3-1.25l0-.09.12-.42v0c.14-.45.29-.89.44-1.33l0-.09.15-.41,0-.05c.15-.42.31-.83.47-1.22l0-.11.15-.35,0-.1.33-.78h0l2.53,7.81s1.39,5.82.64,7.19.86,7.1,1.93,7.2l-1,7.2a110.07,110.07,0,0,0-1,12c-.07.45-.14.84-.19,1.14-.69,3.68,1,9.4,1,9.4,8.47,10,18.55.78,18.55.78s1.18-5.3,0-6.35-.64-4.87-.64-4.87.53-9.42.64-16.3-5.63-12.93-5.63-12.93l-.32.29c-1-2.69-2.23-5.84-2-7.25.43-2.43-1.18-28.14-1.18-28.14a153.47,153.47,0,0,0,.37-20.68h0c.14-1.17.27-2.32.4-3.43.65-5.53,1.17-10.26,1.38-12.73v0l0-.29c.05-.67.08-1.14.07-1.37,0-.82,0-1.85.08-2.93.21-3,.67-6.28.67-6.28l2.25-13.65s1.71-6.66,4.18-10.37l.29-.47v0c.1-.16.2-.34.3-.53l0-.08.3-.57,0-.08c.35-.68.72-1.47,1.1-2.33l.09-.19.29-.66.11-.26.29-.66c0-.09.07-.17.11-.26.11-.27.22-.54.34-.81l.16-.39c.09-.2.17-.4.25-.61l.22-.52.15-.39.24-.59c0-.09.08-.18.11-.27.61-1.53,1.21-3,1.73-4.42h0c.17-.43.33-.84.48-1.24,5.49.34,9.22.65,9.22.65s1.72-12.38,1.18-20.53c-.37-5.56.66-12.56,1.35-16.43.08-.43.15-.81.21-1.15l.15.12c2.69,2.11,4.61-4.87,4.61-4.87s-.72-6.53-1.69-14.42c0-.26-.07-.53-.1-.79a41.52,41.52,0,0,0,4.69.72s.86-.08,2-.23a56.82,56.82,0,0,0,10.18,4.56l5.68-10.58a43.14,43.14,0,0,1,3.75-6.24c1.72-2.12,7.83-8.89,7.72-10.16s2-8.57,4.18-11.85S300.12,477,300,476.46Zm-23.8,8c-2.25.95-4.4,6.24-4.5,7.83s-2.47,8.57-4.94,9.42c-2.26.78-6.6,4.76-7.29,5.4-.71.07-1.51.16-2.35.3-.94-6.68-1.87-12.2-2.47-13.32-1.71-3.18,1.89-13.33,1.89-13.33s.36-10.26,2.61-12.7,1.72-8.57,1.72-8.57.53-2.54.75-3.7,3.19,0,3.21,0h0s5.79,3.17,6.65,7.93,7.18,13,7.18,13-1,2.85,0,4.34S278.46,483.55,276.21,484.5Z",
  transform: "translate(-36.6 -133.2)",
  fill: "url(#f94edff0-5540-4209-9ffe-d34bff61dab8)"
});

var _ref175 =
/*#__PURE__*/
React.createElement("path", {
  d: "M121.15,394.07a17.29,17.29,0,0,1,17.32-8.13V398.3H131l-5.92-1.53Z",
  transform: "translate(-36.6 -133.2)",
  fill: "#4c4981"
});

var _ref176 =
/*#__PURE__*/
React.createElement("path", {
  d: "M121.15,394.07a17.29,17.29,0,0,1,17.32-8.13V398.3H131l-5.92-1.53Z",
  transform: "translate(-36.6 -133.2)",
  opacity: 0.1
});

var _ref177 =
/*#__PURE__*/
React.createElement("path", {
  d: "M139,389.21l-9.19,6.45s-.08-1.3-.31-3.06c-.46-3.33-1.49-8.33-3.71-9.3-3.38-1.48-41-15.63-27.66-20.38s33.79,10.83,33.79,10.83,1.06.36,2.74,3.85c.89,1.83,2,4.95,2.94,7.49C138.41,387.39,139,389.21,139,389.21Z",
  transform: "translate(-36.6 -133.2)",
  fill: "#ae6e79"
});

var _ref178 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "175.88 265.94 176.92 265.44 179.86 268.79 177.46 273.91 173.37 272.27 174.32 268.18 175.88 265.94",
  fill: "#4c4981"
});

var _ref179 =
/*#__PURE__*/
React.createElement("path", {
  d: "M198.56,699.07s-2.64-.31-3.7,3.8-2.64,15.53-2.64,15.53-.63,7-1.9,8.55-2.53,11.51,6.44,12.78,12.89-4.83,12.89-4.83l-.32-27.7Z",
  transform: "translate(-36.6 -133.2)",
  fill: "#444053"
});

var _ref180 =
/*#__PURE__*/
React.createElement("path", {
  d: "M229.87,700.32s5.65,6,5.55,12.9-.64,16.27-.64,16.27-.52,3.8.64,4.86,0,6.33,0,6.33-9.93,9.22-18.27-.77c0,0-1.63-5.71-1-9.39s2.53-20.25,2.53-20.25Z",
  transform: "translate(-36.6 -133.2)",
  fill: "#444053"
});

var _ref181 =
/*#__PURE__*/
React.createElement("path", {
  d: "M243.87,574s-5.71,16-8.14,19.64S231.62,604,231.62,604l-2.22,13.63a74.75,74.75,0,0,0-.74,9.19c.1,3.06-5.49,47.73-5.49,47.73l-8.87,11.3s-3.91,7.92-3.28,11.2-.42,8.55-1.69,10.13c0,0-.21,10.35-.53,12.68s1.17,8.87,0,10-16.68.63-17.11-1.27,1.91-11.09,1.91-11.09l1.37-8.87s2.74-4.86,2.11-6.44,1.16-5.28,1.27-5.6,3-5.49,2.43-7.49,3.27-44.57,3.27-44.57l10.88-76.36Z",
  transform: "translate(-36.6 -133.2)",
  fill: "#ae6e79"
});

var _ref182 =
/*#__PURE__*/
React.createElement("path", {
  d: "M243.87,574s-.86,2.4-2.06,5.56c-1.88,5-4.59,11.82-6.08,14.08-2.43,3.7-4.12,10.35-4.12,10.35l-2.21,13.63a74.73,74.73,0,0,0-.74,9.18c0,1.21-.81,8.93-1.85,17.81-1.6,13.59-3.64,29.93-3.64,29.93l-8.88,11.3s-.45.91-1,2.23c-1.11,2.59-2.68,6.8-2.26,9,.63,3.28-.42,8.56-1.69,10.14,0,0-.21,10.36-.53,12.67s1.17,8.88,0,10-16.68.64-17.11-1.27,1.9-11.08,1.9-11.08l1.38-8.88s2.74-4.86,2.11-6.44,1.16-5.28,1.27-5.6,3-5.49,2.43-7.5c-.41-1.53,1.7-26.54,2.72-38.4.33-3.74.55-6.16.55-6.16l9.36-65.69.75-5.3.77-5.37Z",
  transform: "translate(-36.6 -133.2)",
  opacity: 0.1
});

var _ref183 =
/*#__PURE__*/
React.createElement("path", {
  d: "M234.36,732.87c.1,1.16-14.89,2.85-17,1.58s0-17,0-17l1-7.18c-1.06-.11-2.64-5.81-1.9-7.19s-.64-7.18-.64-7.18l-2.49-7.8-1.52-4.76c-2.46-5.45-6-21-8.26-32.6-1.4-7.29-2.29-13-2.09-13.77.53-1.9-.85-15.73-.85-15.73s-1.68-14-4-18.48c-1.54-2.94-4.55-14-6.42-21.09-.95-3.65-1.61-6.27-1.61-6.27s16-1.34,25.64-1.81c4.46-.21,7.58-.24,7.21.13s-.45,2.3-.43,5.09c0,7.25,1.05,20,2.12,23.42,1.48,4.75,3,19,2.32,20.38s-.42,10.56-.42,10.56a47.43,47.43,0,0,1,1.85,11.47,154.79,154.79,0,0,1-.37,20.64s1.59,25.66,1.16,28.09,3.38,10,3.38,11.51S232,716.39,232,716.39,234.26,731.71,234.36,732.87Z",
  transform: "translate(-36.6 -133.2)",
  fill: "#ae6e79"
});

var _ref184 =
/*#__PURE__*/
React.createElement("path", {
  d: "M242.7,424.38l-1.82,2-1.18,1.27L232.78,435l-17.85,2-9.48-2.54-2.35-.62s0-4.77.43-10.49c.6-7.33,2.05-16.24,5.49-18.66a13.64,13.64,0,0,0,4-5.09,28.49,28.49,0,0,0,1.73-4.27c.07-.19.12-.37.18-.55a46.79,46.79,0,0,0,1.68-7.84s2.28-1.26,5.44-2.73c8.27-3.86,22.55-9.18,17.58,2.73a44.91,44.91,0,0,0-1.86,5.36c-.08.26-.15.53-.21.79-1.66,6.64-.56,10.66.68,12.88h0a9,9,0,0,0,.72,1.09,5.5,5.5,0,0,0,1.2,1.22l2.06,13.05.17,1.08Z",
  transform: "translate(-36.6 -133.2)",
  fill: "#ae6e79"
});

var _ref185 =
/*#__PURE__*/
React.createElement("path", {
  d: "M239.64,387.63c-.94,2.26.46-1.85,0,0-3.76,2.68-12.63,10.3-17.62,10.3-3.36,0-4.37-.61-7.26-1.91a46.9,46.9,0,0,0,1.86-8.39S246.5,371.15,239.64,387.63Z",
  transform: "translate(-36.6 -133.2)",
  opacity: 0.1
});

var _ref186 =
/*#__PURE__*/
React.createElement("path", {
  d: "M247.23,373.75a23,23,0,0,1-20.61,22.89,21.37,21.37,0,0,1-2.41.13,23,23,0,1,1,23-23Z",
  transform: "translate(-36.6 -133.2)",
  fill: "#ae6e79"
});

var _ref187 =
/*#__PURE__*/
React.createElement("path", {
  d: "M250.52,475.81l-3.27,8.56s-2.68.12-6.84.25c-14,.45-45,1-46.39-2.58a8.67,8.67,0,0,1-.48-2.84c-.19-5.5,2.38-13.95,2.38-13.95s1.48-16.9,1.48-17.63S196.13,435,196.13,435l2.53-9.5,7.08-5s3.17,4.86,5.07,5.28,4.44,2.75,4.44,2.75,6.22,3.8,8.23,1.68,17.64-11.4,17.64-11.4l8.24,9.08Z",
  transform: "translate(-36.6 -133.2)",
  opacity: 0.1
});

var _ref188 =
/*#__PURE__*/
React.createElement("path", {
  d: "M250.52,477.08l-3.27,8.56s-2.68.12-6.84.24l-.41,0-6.07.16c-11.16.25-26.55.32-34.58-.85-3-.44-5-1-5.33-1.9a7,7,0,0,1-.38-1.57,12.58,12.58,0,0,1-.1-1.27c-.19-5.5,2.38-14,2.38-14s1.48-16.9,1.48-17.64-1.27-12.57-1.27-12.57l2.53-9.5,4.87-3.41,2.21-1.55a31.92,31.92,0,0,0,2.43,3.19,6.36,6.36,0,0,0,2.64,2.08c1.9.43,4.44,2.75,4.44,2.75s6.22,3.81,8.23,1.69c1.54-1.62,11-7.43,15.42-10.08l2.22-1.33,1.11,1.23,7.13,7.86Z",
  transform: "translate(-36.6 -133.2)",
  fill: "#fff"
});

var _ref189 =
/*#__PURE__*/
React.createElement("path", {
  d: "M139,389.21l-9.19,6.45s-.08-1.3-.31-3.06c4.54-1.91,7.3-6.15,8.1-7.51C138.41,387.39,139,389.21,139,389.21Z",
  transform: "translate(-36.6 -133.2)",
  opacity: 0.1
});

var _ref190 =
/*#__PURE__*/
React.createElement("path", {
  d: "M171.31,411.07l-2-.52s-3.28,3.48-5.18,3.9-5.91,3.07-5.91,3.07l-4.65,3.69s-3.49.53-2.43-1.9-1.9-5.49-1.9-5.49-5.91-12.15-5.91-14.68-4.86-13.2-4.86-13.2-6.13,11.93-17.32,8.13c0,0,8.13,18.27,8.34,22.81s5.6,17.22,5.6,17.22,2,9.4,12.88,8.87c0,0,15,2.79,18.27,0s6.23-5,7.82-5.3a6.19,6.19,0,0,0,2.95-2.11V423Z",
  transform: "translate(-36.6 -133.2)",
  fill: "#3f3d56"
});

var _ref191 =
/*#__PURE__*/
React.createElement("path", {
  d: "M152.51,423s2.64,9.82,1,10.88Z",
  transform: "translate(-36.6 -133.2)",
  opacity: 0.1
});

var _ref192 =
/*#__PURE__*/
React.createElement("path", {
  d: "M240.41,485.88c-14,.45-45,1-46.39-2.57a8.67,8.67,0,0,1-.48-2.84l45.89,2.42Z",
  transform: "translate(-36.6 -133.2)",
  opacity: 0.1
});

var _ref193 =
/*#__PURE__*/
React.createElement("path", {
  d: "M243.87,574s-.86,2.4-2.05,5.56c-5.83-.36-13.55-.73-20.88-.78-2.6,0-5.14,0-7.53.08a56.41,56.41,0,0,0-12.31,1.37,32.48,32.48,0,0,1-11,1.41c-.95-3.65-1.61-6.27-1.61-6.27s16-1.34,25.64-1.81l.77-5.37Z",
  transform: "translate(-36.6 -133.2)",
  opacity: 0.1
});

var _ref194 =
/*#__PURE__*/
React.createElement("path", {
  d: "M256.22,535.38l-1.79,3.8s-.25,1.13-.57,2.93c-.68,3.86-1.7,10.85-1.34,16.4.54,8.13-1.16,20.48-1.16,20.48s-38.86-3.27-50.26,0-17,0-17,0,1.37-12.25-2-18.58c-2.32-4.34-3.94-23.6-4-36.25,0-5.85.29-10.28,1-11.17,2.32-2.86,12.25-31.37,12.25-31.37l2.26.12,6,.32L234,483.87l5.39.28.57,1.75Z",
  transform: "translate(-36.6 -133.2)",
  fill: "#65617d"
});

var _ref195 =
/*#__PURE__*/
React.createElement("path", {
  d: "M273.33,522.7l.32,3.38s-17-5.54-16.16-12.35,0-6,0-6l13.68,1.16Z",
  transform: "translate(-36.6 -133.2)",
  fill: "#4c4981"
});

var _ref196 =
/*#__PURE__*/
React.createElement("path", {
  d: "M273.33,522.7l.32,3.38s-17-5.54-16.16-12.35,0-6,0-6l13.68,1.16Z",
  transform: "translate(-36.6 -133.2)",
  opacity: 0.1
});

var _ref197 =
/*#__PURE__*/
React.createElement("path", {
  d: "M163.87,425.73a15.17,15.17,0,0,0,6,3.12,3.9,3.9,0,0,1-1.77-.83c-1.22-.87-2.38-1.81-3.55-2.73-.94-.74-2.13-2-3.3-2.27A18.21,18.21,0,0,0,163.87,425.73Z",
  transform: "translate(-36.6 -133.2)",
  opacity: 0.1
});

var _ref198 =
/*#__PURE__*/
React.createElement("path", {
  d: "M164.13,430.18a7.35,7.35,0,0,1,1.31,2.09,8.4,8.4,0,0,1,.38,2.7,8.52,8.52,0,0,1-.47,3.83l-2.77-6.57c-.47-1.12-1-2.24-1.52-3.32-.25-.46-1.82-2.36-1.64-2.76C159.94,425,163.62,429.55,164.13,430.18Z",
  transform: "translate(-36.6 -133.2)",
  opacity: 0.1
});

var _ref199 =
/*#__PURE__*/
React.createElement("path", {
  d: "M240.27,466.62a8.84,8.84,0,0,0,5-2.31c-2.81.35-5.46,1.45-8.23,2a12.23,12.23,0,0,1-7.67-.7C232.52,467.19,236.85,467.24,240.27,466.62Z",
  transform: "translate(-36.6 -133.2)",
  opacity: 0.1
});

var _ref200 =
/*#__PURE__*/
React.createElement("path", {
  d: "M232.34,447.29a1.89,1.89,0,0,1-1.43-.36q-3.16-1.8-6.24-3.78a37.85,37.85,0,0,1-6.1-4.22C222.76,442.72,226.66,445.92,232.34,447.29Z",
  transform: "translate(-36.6 -133.2)",
  opacity: 0.1
});

var _ref201 =
/*#__PURE__*/
React.createElement("path", {
  d: "M238.2,469.69a13.42,13.42,0,0,0,3.29-.26,4.45,4.45,0,0,0,2.71-1.78,1.53,1.53,0,0,0-1.15.18,19.42,19.42,0,0,1-10.6,1.27C234.16,469.83,236.37,469.68,238.2,469.69Z",
  transform: "translate(-36.6 -133.2)",
  opacity: 0.1
});

var _ref202 =
/*#__PURE__*/
React.createElement("path", {
  d: "M218.19,518.72a33.89,33.89,0,0,1-6.75,1.33,41.43,41.43,0,0,1-5.34-.1l-8.65-.55-4.33-.28c-.51,0-2.6,0-1.57-1,.52-.49,3.41-.18,4.15-.2,1.44,0,2.87-.07,4.3-.08,2.86,0,5.73,0,8.59.18Q213.41,518.21,218.19,518.72Z",
  transform: "translate(-36.6 -133.2)",
  opacity: 0.1
});

var _ref203 =
/*#__PURE__*/
React.createElement("path", {
  d: "M208.18,523c-1.47-.06-3.36.82-4.87,1a32.07,32.07,0,0,1-5.09.21,28.64,28.64,0,0,1-9.83-2C195,522.54,201.59,522.74,208.18,523Z",
  transform: "translate(-36.6 -133.2)",
  opacity: 0.1
});

var _ref204 =
/*#__PURE__*/
React.createElement("path", {
  d: "M189.68,527.53a15.51,15.51,0,0,1,1.89.51c3.64,1.05,7.52.13,11.19-.78-.92,1.38-2.63,2-4.25,2.36a20,20,0,0,1-8.29.3c-.87-.17-3-.48-3.48-1.38C186.08,527.21,188.87,527.4,189.68,527.53Z",
  transform: "translate(-36.6 -133.2)",
  opacity: 0.1
});

var _ref205 =
/*#__PURE__*/
React.createElement("path", {
  d: "M210.13,534.34a30.66,30.66,0,0,1,3.23.84c4.1,1,8.36-.38,12.48-1.32a57.73,57.73,0,0,1,15.11-1.4c-.91,0-2.35.8-3.24,1.07-1.17.35-2.35.67-3.53,1a71,71,0,0,1-7.06,1.38,72.31,72.31,0,0,1-14.48.63c-2.21-.12-6,.11-7.94-1A8.78,8.78,0,0,1,210.13,534.34Z",
  transform: "translate(-36.6 -133.2)",
  opacity: 0.1
});

var _ref206 =
/*#__PURE__*/
React.createElement("path", {
  d: "M211.66,404.09s.21,9.73-1.38,14.16c-.49,1.38-1.27,3.93-2.11,6.79-.93,3.17-1.94,6.72-2.72,9.47s-1.29,4.65-1.29,4.65-3.57,29.06-4.5,42.9c0,.24,0,.49,0,.72-.05.78-.14,1.59-.26,2.43-2.06,13.75-13.92,34.95-17.9,36.65a12,12,0,0,0-3.35,2.3c0-5.85.29-10.28,1-11.17,2.32-2.86,12.25-31.37,12.25-31.37l2.26.12a12.58,12.58,0,0,1-.1-1.27c-.19-5.5,2.38-14,2.38-14s1.48-16.9,1.48-17.64-1.27-12.57-1.27-12.57l2.53-9.5,4.87-3.41c.6-7.33,2.05-16.24,5.49-18.66a13.64,13.64,0,0,0,4-5.09c.69.09-.56-.51-.56-.51Z",
  transform: "translate(-36.6 -133.2)",
  opacity: 0.1
});

var _ref207 =
/*#__PURE__*/
React.createElement("path", {
  d: "M213.52,398.64a6.32,6.32,0,0,0-5.35.61c-2.43,1.68-7.18,1.58-8.45,1.26s-14.47-2-15.52-1.58-3.17-1.48-4.54,1.05-2,3.91-3.38,4.55-3.81,2.64-3.49,3.06-3.48,3-3.48,3l7.7,25s-5,31.68-7.39,34.42-24,38.34-16.26,44.68a155.94,155.94,0,0,0,19.32,13c.85.42,3.91-5.28,8.14-7.08S198.14,495,199,481.52s4.54-43.62,4.54-43.62,4.54-16.48,6.13-20.91S211,402.82,211,402.82Z",
  transform: "translate(-36.6 -133.2)",
  fill: "#3f3d56"
});

var _ref208 =
/*#__PURE__*/
React.createElement("path", {
  d: "M256.22,535.38l-1.79,3.8s-.25,1.13-.57,2.93a1.66,1.66,0,0,1-.91-.39c-2.64-2.12-18.17-18.06-18.9-32.22-.55-10.44-.29-19.43-.12-23.44.06-1.26.1-2,.11-2.19a.08.08,0,0,0,0,0s12-14.58,10.66-19.75-4.54-32.85-4.54-32.85l-.47-3.63-.8-6.13L237,406.65l2,.46a5.5,5.5,0,0,0,1.2,1.22l2.06,13.05,7.13,7.86,1.16,47.84-3.27,8.56s-2.68.12-6.84.24l-.41,0Z",
  transform: "translate(-36.6 -133.2)",
  opacity: 0.1
});

var _ref209 =
/*#__PURE__*/
React.createElement("path", {
  d: "M262.88,456.38s-3-1.16-3.17,0-.74,3.69-.74,3.69.52,6.13-1.69,8.56-2.57,12.67-2.57,12.67-3.55,10.14-1.87,13.31c.61,1.15,1.56,6.92,2.51,13.82.6,4.31,1.2,9.06,1.74,13.39,1,7.89,1.67,14.4,1.67,14.4s-1.9,7-4.54,4.86S236.05,523,235.31,508.87c-.52-9.95-.31-18.58-.14-22.84.08-1.81.14-2.83.14-2.83s12-14.57,10.67-19.74-4.54-32.85-4.54-32.85l-.56-4.27-.59-4.6-.13-1L238.25,406h0c.34.07,12.19,2.75,13.75,4.31s11.19,3.8,11.19,3.8a8.47,8.47,0,0,1,6,6.16c.09.29.16.6.23.92,1.27,6.13.85,6.86,1.7,7.92S262.88,456.38,262.88,456.38Z",
  transform: "translate(-36.6 -133.2)",
  fill: "#3f3d56"
});

var _ref210 =
/*#__PURE__*/
React.createElement("path", {
  d: "M257.09,521.82c-4.34-.84-10.73-2.85-10.59-7.25.14-4.13,5.1-5.61,8.85-6.14C256,512.74,256.55,517.49,257.09,521.82Z",
  transform: "translate(-36.6 -133.2)",
  opacity: 0.1
});

var _ref211 =
/*#__PURE__*/
React.createElement("path", {
  d: "M270.48,519.64c-.17.37-.89.69-1.84,1a48.26,48.26,0,0,1-7,1.14s-14.68-1.16-14.47-7.81c.15-4.78,6.78-6,10.51-6.33,1.46-.13,2.48-.11,2.48-.11S271.12,518.27,270.48,519.64Z",
  transform: "translate(-36.6 -133.2)",
  fill: "#ae6e79"
});

var _ref212 =
/*#__PURE__*/
React.createElement("path", {
  d: "M270.48,519.64c-.17.37-.89.69-1.84,1-3.83-5.12-9.17-11.69-11.78-12.27,0,0,.3-.29.79-.73,1.46-.13,2.48-.11,2.48-.11S271.12,518.27,270.48,519.64Z",
  transform: "translate(-36.6 -133.2)",
  opacity: 0.1
});

var _ref213 =
/*#__PURE__*/
React.createElement("path", {
  d: "M266.78,428.5l4.33.63a74.44,74.44,0,0,0,5.18,7.92,8.61,8.61,0,0,1,1.9,5.07s6.34,9.4,8.34,10.46,5.07,8.24,5.07,8.24,5,3.27,5,7a61,61,0,0,0,.95,9.18c.1.53-.74,7.08-2.86,10.35s-4.22,10.56-4.11,11.83-5.92,8-7.61,10.14a42.67,42.67,0,0,0-3.69,6.23l-5.6,10.56s-11.83-17.42-16.16-18.37c0,0,4.86-4.65,7.29-5.49s4.75-7.82,4.86-9.4,2.21-6.87,4.43-7.82,3.38-1.9,2.43-3.38,0-4.33,0-4.33-6.23-8.24-7.08-13-6.54-7.92-6.54-7.92l-3.28-8Z",
  transform: "translate(-36.6 -133.2)",
  fill: "#3f3d56"
});

var _ref214 =
/*#__PURE__*/
React.createElement("path", {
  d: "M282.49,467.92a13.69,13.69,0,0,1,8.53-3.23c-2,.35-4.12.78-5.58,2.18a12.74,12.74,0,0,0-1.54,2c-.51.72-4.58,5.9-5.23,5.09C277.7,472.72,281.67,468.62,282.49,467.92Z",
  transform: "translate(-36.6 -133.2)",
  opacity: 0.1
});

var _ref215 =
/*#__PURE__*/
React.createElement("path", {
  d: "M272.93,462.92a3.64,3.64,0,0,0,3-2.13,12,12,0,0,0,.94-3.75,55.58,55.58,0,0,1,1.31-6.41,4.08,4.08,0,0,0,.21-1.34A3.79,3.79,0,0,0,278,448a9.2,9.2,0,0,0-.92-1.92c-.79.89-1,2.88-1.33,4q-.58,2.16-1.11,4.32C274.47,455.16,273,462.92,272.93,462.92Z",
  transform: "translate(-36.6 -133.2)",
  opacity: 0.1
});

var _ref216 =
/*#__PURE__*/
React.createElement("path", {
  d: "M269.19,420.29a9.42,9.42,0,0,1-1.46,1.5c-1.69,1.37-4,2.53-4.24,4.69a5.17,5.17,0,0,1-.25,2.09c-.55.94-1.91.87-3,.68a5.28,5.28,0,0,1-2.53-.93c-1.13-1-1.24-2.7-2.1-3.91a5.34,5.34,0,0,0-4.28-1.92c-1.62-.05-3.23.31-4.84.39a13.41,13.41,0,0,1-3.1-.21c-.34-.06-.67-.13-1-.21a13.12,13.12,0,0,1-2.11-.72,10.64,10.64,0,0,1-1-.48,13.59,13.59,0,0,1-3-2.07c-1.58-1.46-2.89-3.45-2.76-5.61a34.46,34.46,0,0,1,.9-3.84c.65-3.73-1.83-7.26-4.52-9.93-1.07-1.05-2.21-2.09-3.28-3.17a15.82,15.82,0,0,1-3.87-5.5,16.76,16.76,0,0,1-.69-6.88,46.79,46.79,0,0,0,.21-7.09c-.8-8.4-8-14.83-15.14-18.34l-.31-.16a23,23,0,1,1,31,33.68c-.08.26-.15.53-.21.79-1.66,6.64-.56,10.66.68,12.88h0c.34.07,12.19,2.75,13.75,4.31s11.19,3.8,11.19,3.8A8.47,8.47,0,0,1,269.19,420.29Z",
  transform: "translate(-36.6 -133.2)",
  opacity: 0.1
});

var _ref217 =
/*#__PURE__*/
React.createElement("path", {
  d: "M205.23,352.55c.47-.54,1.19-.82,1.67-1.35,1.49-1.62,0-4.27.55-6.41.59-2.38,3.5-3.42,5.94-3.16s4.72,1.37,7.15,1.64c3.78.43,7.44-1.21,11.13-2.17s8.14-1,10.69,1.81,2.36,7.64,5.52,9.69c1.46.94,3.3,1,4.88,1.75a10.12,10.12,0,0,1,4.13,3.95A20.69,20.69,0,0,1,260,371.53c-.26,2.5-1,4.94-1.28,7.44a21.7,21.7,0,0,0,.51,7.78c.67,2.63,2.11,5.39,4.7,6.22a7.38,7.38,0,0,1,1.75.6c1.49.92,1.3,3.12.92,4.83L265,405.45c1.48,1.13,3.77.64,5.21,1.83a4.23,4.23,0,0,1,1.21,1.9,10.39,10.39,0,0,1-3.1,11.34c-1.69,1.38-4,2.53-4.24,4.7a5,5,0,0,1-.25,2.08c-.55.94-1.91.87-3,.68a5.18,5.18,0,0,1-2.52-.93c-1.14-1-1.24-2.7-2.1-3.91a5.34,5.34,0,0,0-4.28-1.92c-1.63-.05-3.23.31-4.85.39a14.27,14.27,0,0,1-10.21-3.69,7.4,7.4,0,0,1-2.77-5.6,37,37,0,0,1,.9-3.85c.65-3.72-1.83-7.26-4.51-9.92s-5.84-5.13-7.15-8.68c-1.64-4.4,0-9.3-.49-14-.8-8.4-8-14.83-15.13-18.33C206.09,356.75,203.37,354.66,205.23,352.55Z",
  transform: "translate(-36.6 -133.2)",
  fill: "#444053"
});

var _ref218 =
/*#__PURE__*/
React.createElement("path", {
  d: "M261.7,425.07c-1.13-1-1.23-2.69-2.09-3.91a5.38,5.38,0,0,0-4.29-1.91c-1.62-.05-3.22.31-4.84.39A14.32,14.32,0,0,1,240.27,416c-1.59-1.46-2.89-3.46-2.77-5.61a36.83,36.83,0,0,1,.9-3.84c.65-3.73-1.83-7.26-4.52-9.93s-5.83-5.13-7.15-8.68c-1.63-4.39,0-9.3-.48-14-.8-8.4-8-14.84-15.14-18.34-1.67-.82-4.39-2.9-2.53-5,.47-.54,1.18-.81,1.67-1.34,1.49-1.62,0-4.28.55-6.42a3.39,3.39,0,0,1,.54-1.17,4.57,4.57,0,0,0-3.89,3.07c-.53,2.14.94,4.8-.55,6.42-.48.53-1.2.8-1.67,1.34-1.86,2.12.86,4.2,2.54,5,7.17,3.51,14.33,9.94,15.13,18.34.44,4.66-1.15,9.57.49,14,1.31,3.55,4.46,6,7.15,8.68s5.16,6.2,4.51,9.93a37.44,37.44,0,0,0-.9,3.84c-.12,2.15,1.18,4.15,2.77,5.61a14.27,14.27,0,0,0,10.21,3.69c1.62-.08,3.22-.44,4.85-.39a5.36,5.36,0,0,1,4.28,1.91c.86,1.22,1,2.95,2.1,3.91a5.18,5.18,0,0,0,2.52.93c1.08.2,2.44.27,3-.68a2.36,2.36,0,0,0,.24-1.24A4.86,4.86,0,0,1,261.7,425.07Z",
  transform: "translate(-36.6 -133.2)",
  opacity: 0.1
});

var SvgEmptyThreadList = function SvgEmptyThreadList(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "a09c848c-d5c4-49aa-a19e-91c8e1064310",
    "data-name": "Layer 1",
    width: 1126.81,
    height: 633.59,
    viewBox: "0 0 1126.81 633.59",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? React.createElement("title", null, title) : null, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, _ref70, _ref71, _ref72, _ref73, _ref74, _ref75, _ref76, _ref77, _ref78, _ref79, _ref80, _ref81, _ref82, _ref83, _ref84, _ref85, _ref86, _ref87, _ref88, _ref89, _ref90, _ref91, _ref92, _ref93, _ref94, _ref95, _ref96, _ref97, _ref98, _ref99, _ref100, _ref101, _ref102, _ref103, _ref104, _ref105, _ref106, _ref107, _ref108, _ref109, _ref110, _ref111, _ref112, _ref113, _ref114, _ref115, _ref116, _ref117, _ref118, _ref119, _ref120, _ref121, _ref122, _ref123, _ref124, _ref125, _ref126, _ref127, _ref128, _ref129, _ref130, _ref131, _ref132, _ref133, _ref134, _ref135, _ref136, _ref137, _ref138, _ref139, _ref140, _ref141, _ref142, _ref143, _ref144, _ref145, _ref146, _ref147, _ref148, _ref149, _ref150, _ref151, _ref152, _ref153, _ref154, _ref155, _ref156, _ref157, _ref158, _ref159, _ref160, _ref161, _ref162, _ref163, _ref164, _ref165, _ref166, _ref167, _ref168, _ref169, _ref170, _ref171, _ref172, _ref173, _ref174, _ref175, _ref176, _ref177, _ref178, _ref179, _ref180, _ref181, _ref182, _ref183, _ref184, _ref185, _ref186, _ref187, _ref188, _ref189, _ref190, _ref191, _ref192, _ref193, _ref194, _ref195, _ref196, _ref197, _ref198, _ref199, _ref200, _ref201, _ref202, _ref203, _ref204, _ref205, _ref206, _ref207, _ref208, _ref209, _ref210, _ref211, _ref212, _ref213, _ref214, _ref215, _ref216, _ref217, _ref218);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgEmptyThreadList, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/empty-thread-list.9bad12ef.svg";
export { ForwardRef as ReactComponent };